import { SupportedLanguage } from './languageConfig';

// 다국어 텍스트 인터페이스
interface TranslationItem {
  en: string;
  ko?: string;
  ja?: string;
  'zh-CN'?: string;
  'zh-TW'?: string;
}

// 웹사이트 전체 번역 사전
const translations: Record<string, TranslationItem> = {
  // 공통 텍스트
  'app.name': {
    en: 'KOREA ORDER',
    ko: 'KOREA ORDER',
    ja: 'KOREA ORDER',
    'zh-CN': 'KOREA ORDER',
    'zh-TW': 'KOREA ORDER'
  },
  'app.tagline': {
    en: 'Food delivery made easy',
    ko: '간편한 음식 배달',
    ja: '簡単なフードデリバリー',
    'zh-CN': '简单的食品外送',
    'zh-TW': '簡單的食品外送'
  },
  'common.close': {
    en: 'Close',
    ko: '닫기',
    ja: '閉じる',
    'zh-CN': '关闭',
    'zh-TW': '關閉'
  },
  'common.cancel': {
    en: 'Cancel',
    ko: '취소',
    ja: 'キャンセル',
    'zh-CN': '取消',
    'zh-TW': '取消'
  },
  'common.free': {
    en: 'Free',
    ko: '무료',
    ja: '無料',
    'zh-CN': '免费',
    'zh-TW': '免費'
  },
  'common.loading': {
    en: 'Loading...',
    ko: '로딩 중...',
    ja: '読み込み中...',
    'zh-CN': '加载中...',
    'zh-TW': '載入中...'
  },
  
  // 헤더
  'header.setAddress': {
    en: 'Choose delivery location',
    ko: '배달 위치 선택',
    ja: '配達先を選択',
    'zh-CN': '选择配送位置',
    'zh-TW': '選擇配送位置'
  },
  'header.allSet': {
    en: "You're all set - Start your order!",
    ko: '모든 준비 완료 - 주문을 시작하세요!',
    ja: '準備完了 - ご注文を始めましょう！',
    'zh-CN': '一切就绪－开始下单吧！',
    'zh-TW': '一切就緒－開始下單吧！'
  },
  'header.addressNotSet': {
    en: 'Full address not set (Tap to enter)',
    ko: '전체 주소가 설정되지 않았습니다 (탭하여 입력)',
    ja: '住所が未設定（タップして入力）',
    'zh-CN': '地址未设置（点击输入）',
    'zh-TW': '地址未設置（點擊輸入）'
  },
  
  // 홈 화면
  'home.popularChains': {
    en: 'Popular Chains',
    ko: '인기 체인점',
    ja: '人気チェーン店',
    'zh-CN': '热门连锁店',
    'zh-TW': '熱門連鎖店'
  },
  
  // 로딩 상태
  'status.loading.chains': {
    en: 'Loading popular chains...',
    ko: '인기 체인점 불러오는 중...',
    ja: '人気チェーンを読み込み中...',
    'zh-CN': '正在加载热门连锁店...',
    'zh-TW': '正在載入熱門連鎖店...'
  },
  'status.loading.categories': {
    en: 'Loading categories...',
    ko: '카테고리 불러오는 중...',
    ja: 'カテゴリーを読み込み中...',
    'zh-CN': '正在加载分类...',
    'zh-TW': '正在載入分類...'
  },
  
  // 에러 상태
  'status.error.retry': {
    en: 'Retry',
    ko: '다시 시도',
    ja: '再試行する',
    'zh-CN': '重新尝试',
    'zh-TW': '重新嘗試'
  },
  
  // 빈 상태
  'status.empty.chains': {
    en: 'No popular chains found.',
    ko: '인기 체인점이 없습니다',
    ja: '人気チェーン店が見つかりませんでした',
    'zh-CN': '暂无热门连锁店',
    'zh-TW': '目前沒有熱門連鎖店'
  },
  'status.empty.categories': {
    en: 'No categories found',
    ko: '카테고리가 없습니다',
    ja: 'カテゴリーが見つかりません',
    'zh-CN': '未找到类别',
    'zh-TW': '未找到類別'
  },
  
  // 카테고리 관련
  'categories.comingSoon': {
    en: 'more later',
    ko: '곧 출시',
    ja: '近日公開',
    'zh-CN': '即将推出',
    'zh-TW': '即將推出'
  },
  
  // 네비게이션
  'nav.home': {
    en: 'Home',
    ko: '홈',
    ja: 'ホーム',
    'zh-CN': '首页',
    'zh-TW': '首頁'
  },
  'nav.browse': {
    en: 'Browse',
    ko: '둘러보기',
    ja: 'さがす',
    'zh-CN': '浏览找美食',
    'zh-TW': '探索餐廳'
  },
  'nav.guides': {
    en: 'Guides',
    ko: '가이드',
    ja: 'ガイド',
    'zh-CN': '美食指南',
    'zh-TW': '美食指南'
  },
  'nav.cart': {
    en: 'Cart',
    ko: '장바구니',
    ja: 'カート',
    'zh-CN': '购物车',
    'zh-TW': '購物車'
  },
  'nav.address': {
    en: 'Address',
    ko: '주소',
    ja: '住所',
    'zh-CN': '地址',
    'zh-TW': '地址'
  },
  'nav.orders': {
    en: 'Orders',
    ko: '주문',
    ja: '注文',
    'zh-CN': '订单',
    'zh-TW': '訂單'
  },
  'nav.profile': {
    en: 'Profile',
    ko: '프로필',
    ja: 'プロフィール',
    'zh-CN': '个人资料',
    'zh-TW': '個人資料'
  },
  'nav.support': {
    en: 'Support',
    ko: '고객지원',
    ja: 'サポート',
    'zh-CN': '客服支持',
    'zh-TW': '客服支援'
  },
  'nav.support.affordance': {
    en: 'Questions? <strong>Chat with us now!</strong> 👋',
    ko: '궁금한 점이 있으신가요? <strong>지금 채팅하세요!</strong> 👋',
    ja: 'ご質問がありますか？<strong>今すぐチャット！</strong> 👋',
    'zh-CN': '有疑问吗？<strong>现在就聊天吧！</strong> 👋',
    'zh-TW': '有疑問嗎？<strong>現在就聊天吧！</strong> 👋'
  },
  'nav.support.menu_help_affordance': {
    en: 'Need help choosing?<br> <strong>Chat with us.</strong> 🍽️',
    ko: '메뉴 선정이 어려우신가요?<br> <strong>도움이 필요하면 말씀하세요!</strong> 🍽️',
    ja: 'ご注文に迷ったら、<br><strong>チャットでどうぞ。</strong> 🍽️',
    'zh-CN': '不知道吃什麼?<br><strong>歡迎聊聊。</strong> 🍽️',
    'zh-TW': '不知道选什么?<br><strong>欢迎聊天。</strong> 🍽️'
  },
  'nav.support.second_menu_help_affordance': {
    en: 'Still unsure?<br><strong>Chat with us anytime.</strong> 💬',
    ko: '아직도 고민되시나요?<br><strong>언제든지 채팅하세요!</strong> 💬',
    ja: 'まだお悩みでしたら、<br><strong>チャットでご相談ください。</strong> 💬',
    'zh-CN': '還在猶豫嗎?<br><strong>歡迎隨時聊聊。</strong> 💬',
    'zh-TW': '还在犹豫?<br><strong>欢迎随时聊天咨询。</strong> 💬'
  },
  'nav.address.affordance': {
    en: 'Set your address first!<br/><strong>Click here to set address</strong> 📍',
    ko: '먼저 주소를 설정해주세요!<br/><strong>여기를 눌러 주소 설정</strong> 📍',
    ja: 'まず住所を設定してください！<br/><strong>ここをクリックして住所設定</strong> 📍',
    'zh-CN': '請先設置地址！<br/><strong>點擊這裡設置地址</strong> 📍',
    'zh-TW': '請先設置地址！<br/><strong>點擊這裡設置地址</strong> 📍'
  },
  'nav.address.affordance.polling': {
    en: 'Setting your address now.<br/><strong>Just ~3 mins!</strong> ✨',
    ko: '주소를 설정하고 있습니다.<br/><strong>3분만 기다려주세요!</strong> ✨',
    ja: '住所を設定中です。<br/><strong>約3分お待ちください！</strong> ✨',
    'zh-CN': '正在設置您的地址。<br/><strong>請稍等約3分鐘！</strong> ✨',
    'zh-TW': '正在設置您的地址。<br/><strong>請稍等約3分鐘！</strong> ✨'
  },
  'nav.cart.affordance.polling': {
    en: 'Hooray! Almost done!<br/><strong>Setting your location in a sec</strong> 👍',
    ko: '거의 다 됐어요!<br/><strong>곧 위치가 설정됩니다</strong> 👍',
    ja: 'やった！もうすぐ完了！<br/><strong>場所をすぐに設定しますね</strong> 👍',
    'zh-CN': '快完成了！<br/><strong>馬上就能設定好位置</strong> 👍',
    'zh-TW': '快完成了！<br/><strong>馬上就能設定好位置</strong> 👍'
  },
  'nav.address.affordance.success': {
    en: 'Your address is set —<br/><strong>Time to taste Korea!</strong> 🇰🇷 🥢',
    ko: '주소가 설정되었습니다 —<br/><strong>이제 한국 음식을 맛보세요!</strong> 🇰🇷 🥢',
    ja: '住所が設定されました —<br/><strong>韓国料理を楽しみましょう！</strong> 🇰🇷 🥢',
    'zh-CN': '地址已設定 —<br/><strong>是時候品嚐韓國料理了！</strong> 🇰🇷 🥢',
    'zh-TW': '地址已設定 —<br/><strong>是時候品嚐韓國料理了！</strong> 🇰🇷 🥢'
  },
  
  // 주소 설정 페이지
  'address.setup': {
    en: 'Address Setup',
    ko: '주소 설정',
    ja: '住所設定',
    'zh-CN': '地址设置',
    'zh-TW': '地址設定'
  },
  'address.method.title': {
    en: 'Address Setup',
    ko: '주소 설정',
    ja: '住所設定',
    'zh-CN': '地址设置',
    'zh-TW': '地址設定'
  },
  'address.method.screenshot.title': {
    en: 'via Screenshot',
    ko: '스크린샷으로',
    ja: 'スクリーンショットで',
    'zh-CN': '通过截图',
    'zh-TW': '透過截圖'
  },
  'address.method.screenshot.subtitle': {
    en: '* Got a booking screenshot?',
    ko: '* 예약 스크린샷이 있으신가요?',
    ja: '* 予約のスクリーンショットはありますか？',
    'zh-CN': '* 有预订截图吗？',
    'zh-TW': '* 有預訂截圖嗎？'
  },
  'address.method.gps.title': {
    en: 'Use GPS',
    ko: 'GPS 사용',
    ja: 'GPS使用',
    'zh-CN': '使用GPS',
    'zh-TW': '使用GPS'
  },
  'address.method.gps.subtitle': {
    en: '* Just pin it on the map',
    ko: '* 지도에서 핀으로 찍어주세요',
    ja: '* 地図でピンを立ててください',
    'zh-CN': '* 在地图上定位即可',
    'zh-TW': '* 在地圖上定位即可'
  },
  'address.method.manual.title': {
    en: 'Type manually',
    ko: '직접 입력',
    ja: '手動入力',
    'zh-CN': '手动输入',
    'zh-TW': '手動輸入'
  },
  'address.method.manual.subtitle': {
    en: '* Master of Korean Address?',
    ko: '* 한국 주소 전문가이신가요?',
    ja: '* 韓国住所の専門家ですか？',
    'zh-CN': '* 熟悉韩国地址吗？',
    'zh-TW': '* 熟悉韓國地址嗎？'
  },
  'address.backToPreference': {
    en: 'Back to Preference',
    ko: '방법 선택으로 돌아가기',
    ja: '選択方法に戻る',
    'zh-CN': '返回选择方式',
    'zh-TW': '返回選擇方式'
  },
  'address.main': {
    en: 'Main Address',
    ko: '기본 주소',
    ja: 'メイン住所',
    'zh-CN': '主要地址',
    'zh-TW': '主要地址'
  },
  'address.detail': {
    en: 'Detail Address',
    ko: '상세 주소',
    ja: '詳細住所',
    'zh-CN': '详细地址',
    'zh-TW': '詳細地址'
  },
  'address.useGPS': {
    en: 'Use GPS',
    ko: '현재 위치 사용하기',
    ja: 'GPSを使用',
    'zh-CN': '使用GPS',
    'zh-TW': '使用GPS'
  },
  'address.uploadBooking': {
    en: 'Upload Booking Screenshot (OCR)',
    ko: '예약 확인서 업로드',
    ja: '予約スクリーンショットをアップロード（OCR）',
    'zh-CN': '上传预订截图（OCR）',
    'zh-TW': '上傳訂房截圖（OCR）'
  },
  'address.save': {
    en: 'Save Address',
    ko: '주소 저장',
    ja: '住所を保存',
    'zh-CN': '保存地址',
    'zh-TW': '儲存地址'
  },
  'address.confirm': {
    en: 'Confirm Address',
    ko: '주소 확인',
    ja: '住所を確認',
    'zh-CN': '确认地址',
    'zh-TW': '確認地址'
  },
  'address.edit': {
    en: 'Edit Address',
    ko: '주소 수정',
    ja: '住所を編集',
    'zh-CN': '编辑地址',
    'zh-TW': '編輯地址'
  },
  'address.saveChanges': {
    en: 'Save Changes',
    ko: '변경 저장',
    ja: '変更を保存',
    'zh-CN': '保存更改',
    'zh-TW': '儲存變更'
  },
  'address.confirmDialog.title': {
    en: 'Unsaved Changes',
    ko: '저장되지 않은 변경사항',
    ja: '保存されていない変更',
    'zh-CN': '未保存的更改',
    'zh-TW': '未儲存的變更'
  },
  'address.confirmDialog.message': {
    en: 'You have unsaved changes. Are you sure you want to cancel?',
    ko: '저장되지 않은 변경사항이 있습니다. 정말 취소하시겠습니까?',
    ja: '保存されていない変更があります。本当にキャンセルしますか？',
    'zh-CN': '您有未保存的更改。确定要取消吗？',
    'zh-TW': '您有未儲存的變更。確定要取消嗎？'
  },
  'address.confirmDialog.confirm': {
    en: 'Yes, Cancel',
    ko: '네, 취소합니다',
    ja: 'はい、キャンセル',
    'zh-CN': '是的，取消',
    'zh-TW': '是的，取消'
  },
  'address.confirmDialog.cancel': {
    en: 'Continue Editing',
    ko: '계속 편집',
    ja: '編集を続ける',
    'zh-CN': '继续编辑',
    'zh-TW': '繼續編輯'
  },
  'address.help': {
    en: 'Need Help?',
    ko: '도움이 필요하신가요?',
    ja: 'お困りですか？',
    'zh-CN': '需要帮助吗？',
    'zh-TW': '需要幫忙嗎？'
  },
  'address.required': {
    en: 'Main address is required',
    ko: '기본 주소는 필수입니다',
    ja: 'メイン住所を入力してください',
    'zh-CN': '請輸入主要地址',
    'zh-TW': '請輸入主要地址'
  },
  'address.tooShort': {
    en: 'Address is too short',
    ko: '주소가 너무 짧습니다. 전체 주소를 입력해주세요',
    ja: '住所が短すぎます（もう少し詳しく入力してください）',
    'zh-CN': '地址太短，請補充詳細資訊',
    'zh-TW': '地址太短，請補充詳細資訊'
  },
  'address.missingNumber': {
    en: 'Address should include a number (building or street number)',
    ko: '주소에는 번호(건물 또는 도로 번호)가 포함되어야 합니다',
    ja: '住所には番号（建物または街路番号）を含める必要があります',
    'zh-CN': '地址應包含數字（建築物或街道號碼）',
    'zh-TW': '地址應包含數字（建築物或街道號碼）'
  },
  'address.detailRequired': {
    en: 'Detail address is required',
    ko: '상세 주소를 입력해주세요',
    ja: '詳細住所を入力してください',
    'zh-CN': '請輸入詳細地址',
    'zh-TW': '請輸入詳細地址'
  },
  'address.saveFailed': {
    en: 'Failed to save address. Please try again.',
    ko: '주소 저장에 실패했습니다. 다시 시도해주세요.',
    ja: '住所の保存に失敗しました。もう一度お試しください。',
    'zh-CN': '保存地址失败。請重試。',
    'zh-TW': '保存地址失敗。請重試。'
  },
  'address.geocoding.notFound': {
    en: 'Address not found. Please try a different address.',
    ko: '주소를 찾을 수 없습니다. 다른 주소를 시도해보세요.',
    ja: '住所が見つからないため、別の住所をお試しください。',
    'zh-CN': '找不到地址。請嘗試其他地址。',
    'zh-TW': '找不到地址。請嘗試其他地址。'
  },
  'address.geocoding.found': {
    en: 'Location found',
    ko: '위치 찾기 완료',
    ja: '場所が見つかりました',
    'zh-CN': '找到位置',
    'zh-TW': '找到位置'
  },
  'address.stay.banner.title': {
    en: 'Delivery address is all set!',
    ko: '배송 주소가 모두 설정되었습니다!',
    ja: '住所は設定済みです！',
    'zh-CN': '地址已设置！',
    'zh-TW': '地址已設定完成！'
  },
  'address.stay.banner.subtitle': {
    en: 'Already set by your accommodation — no worries 👍',
    ko: '숙소에서 이미 설정해 주었습니다 — 걱정하지 마세요 👍',
    ja: '宿泊先により自動設定済みです 👍🏻',
    'zh-CN': '由住宿自动设置 👍🏻',
    'zh-TW': '由住宿自動設定 👍🏻'
  },
  'address.format.infoLabel': {
    en: 'Why are there two address formats?',
    ko: '왜 주소가 두 개인가요?',
    ja: '住所形式が二つある理由',
    'zh-CN': '为什么有两种地址格式？',
    'zh-TW': '為什麼有兩種地址格式？'
  },
  'address.format.info': {
    en: 'In Korea, one place has two addresses — a road name address and an older lot number (jibun) address. Both point to the same place, so you can match whichever one your host gave you.',
    ko: '한국은 한 장소에 도로명 주소와 지번(옛 방식) 주소 두 가지가 있습니다. 둘 다 같은 장소를 가리키니, 호스트가 준 형식과 맞춰 확인하시면 됩니다.',
    ja: '韓国では一つの場所に道路名住所と地番（旧方式）住所の二つがあります。どちらも同じ場所を指すので、ホストから受け取った形式に合わせて確認できます。',
    'zh-CN': '在韩国，同一地点有两种地址：路名地址和旧式地番(jibun)地址。两者指向同一位置，可与房东提供的格式对照确认。',
    'zh-TW': '在韓國，同一地點有兩種地址：路名地址與舊式地番(jibun)地址。兩者指向同一位置，可與房東提供的格式對照確認。'
  },
  'address.geocoding.error': {
    en: 'An error occurred while searching for the address.',
    ko: '주소 검색 중 오류가 발생했습니다.',
    ja: '住所検索中にエラーが発生しました。',
    'zh-CN': '搜索地址時發生錯誤。',
    'zh-TW': '搜索地址時發生錯誤。'
  },
  'address.gps.permissionDenied': {
    en: 'Location permission denied. Using approximate IP-based location.',
    ko: '위치 권한이 거부되어 IP 기반 대략적 위치를 사용합니다.',
    ja: '位置情報の許可が拒否されました。IPベースの概算位置を使用します。',
    'zh-CN': '位置權限被拒絕。使用基於IP的大致位置。',
    'zh-TW': '位置權限被拒絕。使用基於IP的大致位置。'
  },
  'address.gps.unavailable': {
    en: 'Precise location unavailable. Using approximate IP-based location.',
    ko: '정확한 위치를 사용할 수 없어 IP 기반 대략적 위치를 사용합니다.',
    ja: '正確な位置情報が利用できません。IPベースの概算位置を使用します。',
    'zh-CN': '無法使用精確位置。使用基於IP的大致位置。',
    'zh-TW': '無法使用精確位置。使用基於IP的大致位置。'
  },
  'address.gps.coordinatesOnly': {
    en: 'Address not found. Displaying coordinates instead.',
    ko: '주소를 찾을 수 없어 좌표를 표시합니다.',
    ja: '住所が見つからないため、座標を表示します。',
    'zh-CN': '找不到地址。顯示座標。',
    'zh-TW': '找不到地址。顯示座標。'
  },
  'address.gps.failed': {
    en: 'Failed to get location information. Please enter your address manually.',
    ko: '위치 정보를 가져오는 데 실패했습니다. 직접 주소를 입력해주세요.',
    ja: '位置情報の取得に失敗しました。住所を手動で入力してください。',
    'zh-CN': '获取位置信息失败。請手動輸入地址。',
    'zh-TW': '獲取位置信息失敗。請手動輸入地址。'
  },
  
  // 상태 메시지 - 로딩
  'status.loading.restaurants': {
    en: 'Loading restaurants...',
    ko: '주변 음식점을 찾는 중...',
    ja: 'レストランを読み込み中...',
    'zh-CN': '',
    'zh-TW': '正在載入餐廳...'
  },
  'status.loading.menus': {
    en: 'Loading menus...',
    ko: '메뉴 옵션을 불러오는 중...',
    ja: 'メニューを読み込み中...',
    'zh-CN': '正在加载菜单...',
    'zh-TW': '正在載入菜單...'
  },
  // 여기까지
  
  // 상태 메시지 - 에러
  'status.error.categories': {
    en: 'We had trouble loading categories. Please try again.',
    ko: '카테고리를 불러오는 데 문제가 발생했습니다. 다시 시도해주세요.',
    ja: 'カテゴリーの読み込み中に問題が発生しました。もう一度お試しください。',
    'zh-CN': '加載類別時出現問題。請重試。',
    'zh-TW': '加載類別時出現問題。請重試。'
  },
  'status.error.restaurants': {
    en: 'We couldn\'t load restaurants at this time. Please try again.',
    ko: '현재 음식점 정보를 불러올 수 없습니다. 다시 시도해주세요.',
    ja: '現在、レストラン情報を読み込むことができません。もう一度お試しください。',
    'zh-CN': '目前無法加載餐廳信息。請重試。',
    'zh-TW': '目前無法加載餐廳信息。請重試。'
  },
  'status.error.chains': {
    en: 'We couldn\'t load popular restaurants at this time. Please try again.',
    ko: '현재 인기 음식점을 불러올 수 없습니다. 다시 시도해주세요.',
    ja: '現在、人気のレストランを読み込むことができません。もう一度お試しください。',
    'zh-CN': '目前無法加載熱門餐廳。請重試。',
    'zh-TW': '目前無法加載熱門餐廳。請重試。'
  },
  'status.error.menus': {
    en: 'We couldn\'t load the menu at this time. Please try again.',
    ko: '현재 메뉴를 불러올 수 없습니다. 다시 시도해주세요.',
    ja: '現在、メニューを読み込むことができません。もう一度お試しください。',
    'zh-CN': '目前無法加載菜單。請重試。',
    'zh-TW': '目前無法加載菜單。請重試。'
  },
  'status.error.default': {
    en: 'Something went wrong. Please try again.',
    ko: '문제가 발생했습니다. 다시 시도해주세요.',
    ja: '問題が発生しました。もう一度お試しください。',
    'zh-CN': '出现问题。請重試。',
    'zh-TW': '出現問題。請重試。'
  },
  'status.error.network': {
    en: 'Network connection issue. Please check your internet connection.',
    ko: '네트워크 연결 문제. 인터넷 연결을 확인해주세요.',
    ja: 'ネットワーク接続の問題です。インターネット接続を確認してください。',
    'zh-CN': '網絡連接問題。請檢查您的互聯網連接。',
    'zh-TW': '網絡連接問題。請檢查您的互聯網連接。'
  },
  
  // 상태 메시지 - 비어있음
  'status.empty.restaurants': {
    en: 'No restaurants found in this area.',
    ko: '이 지역에서 음식점을 찾을 수 없습니다.',
    ja: 'この地域にレストランが見つかりません。',
    'zh-CN': '在此區域找不到餐廳。',
    'zh-TW': '在此區域找不到餐廳。'
  },
  'status.empty.menus': {
    en: 'This restaurant has no available menu items.',
    ko: '이 음식점에는 이용 가능한 메뉴 항목이 없습니다.',
    ja: 'このレストランには利用可能なメニュー項目がありません。',
    'zh-CN': '該餐廳沒有可用的菜單項。',
    'zh-TW': '該餐廳沒有可用的菜單項。'
  },
  
  // 레스토랑 정보
  'restaurant.minimumOrder': {
    en: 'Minimum Order',
    ko: '최소 주문 금액',
    ja: '最低注文金額',
    'zh-CN': '最低訂單金額',
    'zh-TW': '最低訂單金額'
  },
  'restaurant.noMinimumOrder': {
    en: 'No Minimum Order',
    ko: '최소 주문 금액 없음',
    ja: '最低注文金額なし',
    'zh-CN': '無最低訂單金額',
    'zh-TW': '無最低訂單金額'
  },
  'restaurant.deliveryTime': {
    en: 'Within 1 hour',
    ko: '1시간 이내',
    ja: '1時間以内',
    'zh-CN': '1小時內',
    'zh-TW': '1小時內'
  },
  'restaurant.deliveryTimeForGiftshop': {
    en: 'Next-day',
    ko: '다음날',
    ja: '翌日お届け',
    'zh-CN': '次日送达',
    'zh-TW': '隔日送達'
  },
  'restaurant.noMenuItems': {
    en: 'No menu items available',
    ko: '이용 가능한 메뉴 항목이 없습니다',
    ja: '利用可能なメニュー項目がありません',
    'zh-CN': '沒有可用的菜單項',
    'zh-TW': '沒有可用的菜單項'
  },
  
  // Browse 페이지
  'browse.allRestaurants': {
    en: 'All Restaurants',
    ko: '모든 음식점',
    ja: 'すべてのレストラン',
    'zh-CN': '所有餐廳',
    'zh-TW': '所有餐廳'
  },
  'browse.restaurants': {
    en: 'Restaurants',
    ko: '음식점',
    ja: 'レストラン',
    'zh-CN': '餐廳',
    'zh-TW': '餐廳'
  },
  'browse.restaurantSingular': {
    en: 'restaurant',
    ko: '음식점',
    ja: 'レストラン',
    'zh-CN': '餐廳',
    'zh-TW': '餐廳'
  },
  'browse.restaurantPlural': {
    en: 'restaurants',
    ko: '음식점',
    ja: 'レストラン',
    'zh-CN': '餐廳',
    'zh-TW': '餐廳'
  },
  'browse.available': {
    en: 'available',
    ko: '이용 가능',
    ja: '利用可能',
    'zh-CN': '可用',
    'zh-TW': '可用'
  },

  // 에러/상태 메시지
  'error.connectionIssue': {
    en: 'Please check your internet connection and try again',
    ko: '인터넷 연결을 확인하고 다시 시도해주세요',
    ja: 'インターネット接続を確認して、もう一度お試しください',
    'zh-CN': '請檢查您的互聯網連接，然後重試',
    'zh-TW': '請檢查您的互聯網連接，然後重試'
  },
  'empty.changeLocationOrCategory': {
    en: 'Try changing your location or category',
    ko: '위치나 카테고리를 변경해 보세요',
    ja: '場所やカテゴリを変更してみてください',
    'zh-CN': '嘗試更改您的位置或類別',
    'zh-TW': '嘗試更改您的位置或類別'
  },
  'action.refresh': {
    en: 'Refresh',
    ko: '새로고침',
    ja: '更新',
    'zh-CN': '刷新',
    'zh-TW': '刷新'
  },
  
  // 장바구니 페이지
  'cart.empty': {
    en: 'Your cart is empty',
    ko: '장바구니가 비어있습니다',
    ja: 'カートは空です',
    'zh-CN': '您的購物車是空的',
    'zh-TW': '您的購物車是空的'
  },
  'cart.addItem': {
    en: 'Add Item',
    ko: '메뉴 추가하기',
    ja: 'アイテムを追加',
    'zh-CN': '添加項目',
    'zh-TW': '添加項目'
  },
  'cart.checkout': {
    en: 'Checkout',
    ko: '결제하기',
    ja: 'お会計',
    'zh-CN': '結算',
    'zh-TW': '結算'
  },
  'cart.deliveryAvailable': {
    en: 'Delivery available',
    ko: '배달 가능',
    ja: '配達可能',
    'zh-CN': '可配送',
    'zh-TW': '可配送'
  },
  'cart.addMore': {
    en: 'Add more items',
    ko: '더 담기',
    ja: 'もっと追加',
    'zh-CN': '添加更多',
    'zh-TW': '添加更多'
  },
  'cart.addMoreAmount': {
    en: 'Add {amount} more',
    ko: '{amount} 더 담기',
    ja: 'あと{amount}追加',
    'zh-CN': '再添加{amount}',
    'zh-TW': '再添加{amount}'
  },
  'cart.browseRestaurants': {
    en: 'Browse Restaurants',
    ko: '음식점 둘러보기',
    ja: 'レストランを見る',
    'zh-CN': '瀏覽餐廳',
    'zh-TW': '瀏覽餐廳'
  },
  'cart.perPiece': {
    en: '(per 1 piece)',
    ko: '(1개당)',
    ja: '(1個あたり)',
    'zh-CN': '(每件)',
    'zh-TW': '(每件)'
  },
  'cart.remove': {
    en: 'Remove',
    ko: '삭제',
    ja: '削除',
    'zh-CN': '刪除',
    'zh-TW': '刪除'
  },
  'cart.decrease': {
    en: 'Decrease quantity of',
    ko: '수량 감소',
    ja: '数量を減らす',
    'zh-CN': '减少數量',
    'zh-TW': '減少數量'
  },
  'cart.increase': {
    en: 'Increase quantity of',
    ko: '수량 증가',
    ja: '数量を増やす',
    'zh-CN': '增加數量',
    'zh-TW': '增加數量'
  },
  'cart.orderSummary': {
    en: 'Order Summary',
    ko: '주문 요약',
    ja: '注文の概要',
    'zh-CN': '訂單摘要',
    'zh-TW': '訂單摘要'
  },
  'cart.subtotal': {
    en: 'Subtotal',
    ko: '소계',
    ja: '小計',
    'zh-CN': '小計',
    'zh-TW': '小計'
  },
  'cart.deliveryFee': {
    en: 'Delivery Fee',
    ko: '배달료',
    ja: '配送料',
    'zh-CN': '配送費',
    'zh-TW': '配送費'
  },
  'cart.proxyFee': {
    en: 'Proxy Ordering Fee',
    ko: '대리 주문 수수료',
    ja: '代理注文手数料',
    'zh-CN': '代理訂購費',
    'zh-TW': '代理訂購費'
  },
  'cart.total': {
    en: 'Total',
    ko: '합계',
    ja: '合計',
    'zh-CN': '總計',
    'zh-TW': '總計'
  },
  'cart.deliveryTime': {
    en: 'Delivery Time',
    ko: '배달 도착 시간',
    ja: '配達到着時間',
    'zh-CN': '配送到達時間',
    'zh-TW': '配送到達時間'
  },
  'cart.immediateDelivery': {
    en: 'Immediate Delivery',
    ko: '바로배달',
    ja: '即時配達',
    'zh-CN': '立即配送',
    'zh-TW': '立即配送'
  },
  'cart.scheduledDelivery': {
    en: 'Scheduled',
    ko: '예약배달',
    ja: '予約配達',
    'zh-CN': '預約配送',
    'zh-TW': '預約配送'
  },
  'cart.selectTimeToday': {
    en: 'Select time today',
    ko: '오늘 중 원하는 시간 선택',
    ja: '今日の希望時間選択',
    'zh-CN': '選擇今日希望時間',
    'zh-TW': '選擇今日希望時間'
  },
  'cart.deliveryTimeSelection': {
    en: 'Scheduled Delivery Time',
    ko: '예약배달 도착 시간',
    ja: '予約配達到着時間',
    'zh-CN': '預約配送到達時間',
    'zh-TW': '預約配送到達時間'
  },
  'cart.selectTime': {
    en: 'Select Time',
    ko: '시간 선택',
    ja: '時間選択',
    'zh-CN': '选择时间',
    'zh-TW': '選擇時間'
  },
  'cart.scheduledDeliveryNotAvailable': {
    en: 'Scheduled delivery is not available at this time',
    ko: '현재 시간에는 예약배달을 이용할 수 없습니다',
    ja: '現在時刻では予約配達をご利用いただけません',
    'zh-CN': '当前时间无法使用预约配送',
    'zh-TW': '目前時間無法使用預約配送'
  },
  'cart.changedToImmediateDelivery': {
    en: 'Scheduled delivery is not available, changed to immediate delivery',
    ko: '현재 시간에는 예약배달을 이용할 수 없어 바로배달로 변경되었습니다',
    ja: '予約配達が利用できないため、即時配達に変更されました',
    'zh-CN': '预约配送不可用，已更改为立即配送',
    'zh-TW': '預約配送不可用，已更改為立即配送'
  },
  'cart.promotionDiscount': {
    en: 'Promotion Discount',
    ko: '프로모션 할인',
    ja: 'プロモーション割引',
    'zh-CN': '促銷折扣',
    'zh-TW': '促銷折扣'
  },
  'cart.toOrder': {
    en: 'more to order',
    ko: '더 추가하여 주문하세요',
    ja: 'もっと追加して注文する',
    'zh-CN': '更多以下訂單',
    'zh-TW': '更多以下訂單'
  },
  'cart.processing': {
    en: 'Processing...',
    ko: '처리 중...',
    ja: '処理中...',
    'zh-CN': '處理中...',
    'zh-TW': '處理中...'
  },
  'cart.proceedToCheckout': {
    en: 'Proceed to Checkout',
    ko: '결제 진행하기',
    ja: '決済に進む',
    'zh-CN': '進行結算',
    'zh-TW': '進行結算'
  },
  'cart.setAddressFirst': {
    en: 'Please set up your delivery address first',
    ko: '먼저 배송 주소를 설정해주세요',
    ja: '配送先住所を先に設定してください',
    'zh-CN': '請先設置您的配送地址',
    'zh-TW': '請先設置您的配送地址'
  },
  'cart.failedToCreateCart': {
    en: 'Failed to create cart',
    ko: '장바구니 생성에 실패했습니다',
    ja: 'カートの作成に失敗しました',
    'zh-CN': '創建購物車失敗',
    'zh-TW': '創建購物車失敗'
  },
  'cart.failedToGetOrderId': {
    en: 'Failed to get order ID',
    ko: '주문 ID를 가져오지 못했습니다',
    ja: '注文IDの取得に失敗しました',
    'zh-CN': '獲取訂單ID失敗',
    'zh-TW': '獲取訂單ID失敗'
  },
  'cart.checkoutFailed': {
    en: 'Failed to proceed to checkout',
    ko: '결제 진행에 실패했습니다',
    ja: '決済に進むことができませんでした',
    'zh-CN': '無法進行結算',
    'zh-TW': '無法進行結算'
  },
  'cart.needMore': {
    en: 'You need to add {amount} more to meet the minimum order amount',
    ko: '최소 주문 금액을 충족하기 위해 {amount}가 더 필요합니다',
    ja: '最低注文金額を満たすためにさらに{amount}が必要です',
    'zh-CN': '您需要再添加{amount}才能達到最低訂單金額',
    'zh-TW': '您需要再添加{amount}才能達到最低訂單金額'
  },
  'cart.minOrderWarning': {
    en: 'Minimum order not met',
    ko: '최소 주문 금액을 충족하지 않았습니다',
    ja: '最低注文金額を満たしていません',
    'zh-CN': '未滿足最低訂單金額',
    'zh-TW': '未滿足最低訂單金額'
  },
  'cart.calculateFailed': {
    en: 'We couldn\'t calculate your order total. Please try again in a moment.',
    ko: '주문 금액을 계산하지 못했습니다. 잠시 후 다시 시도해주세요.',
    ja: '注文金額を計算できませんでした。しばらくしてからもう一度お試しください。',
    'zh-CN': '无法计算订单金额，请稍后再试。',
    'zh-TW': '無法計算訂單金額，請稍後再試。'
  },
  'cart.shopClosedTitle': {
    en: 'This store is no longer available',
    ko: '영업을 종료한 매장입니다',
    ja: 'この店舗は営業を終了しました',
    'zh-CN': '该店铺已停止营业',
    'zh-TW': '此店家已停止營業'
  },
  'cart.shopClosedDescription': {
    en: 'This store has permanently closed, so it can\'t accept orders. Please remove these items and explore other restaurants.',
    ko: '해당 매장이 영업을 종료하여 주문을 받을 수 없습니다. 담긴 상품을 비우고 다른 매장을 둘러보세요.',
    ja: 'この店舗は営業を終了したため、注文を承れません。カートを空にして他の店舗をご覧ください。',
    'zh-CN': '该店铺已永久关闭，无法接受订单。请清空购物车并浏览其他餐厅。',
    'zh-TW': '此店家已永久關閉，無法接受訂單。請清空購物車並瀏覽其他餐廳。'
  },
  'cart.browseOtherRestaurants': {
    en: 'Browse other restaurants',
    ko: '다른 매장 둘러보기',
    ja: '他の店舗を見る',
    'zh-CN': '浏览其他餐厅',
    'zh-TW': '瀏覽其他餐廳'
  },
  'cart.giftShopModalTitle': {
    en: 'Gift & Souvenir Notice',
    ko: '기념품샵 주문 안내',
    ja: 'ギフト・お土産のご注文に関するご案内',
    'zh-CN': '礼品与纪念品订购须知',
    'zh-TW': '禮品與紀念品訂購須知'
  },
  'cart.giftShopModalDetails': {
    en: '• **Delivery: tomorrow** (different from food delivery)\n• **Check-out tomorrow?** You may **miss it** — **refund won\'t be possible**\n• If some items are **sold out**, we\'ll **refund those** and send the rest',
    ko: '• **익일 배송**이 가능합니다.\n• **내일 체크아웃** 예정인 경우 **배송을 받지 못할 수 있으며**, 이 사유로 인한 **환불은 불가능**합니다.\n• 일부 상품이 **품절**인 경우 해당 상품은 **부분 환불**되고 나머지 상품은 정상 발송됩니다.',
    ja: '• **配送：明日**（料理の配達とは異なります）\n• **明日チェックアウト予定ですか？** **商品を受け取れない可能性があります** — **返金はできません**\n• 一部商品が**品切れ**の場合は、**その分を返金**し、残りを発送いたします',
    'zh-CN': '• **配送时间：明天**（与食品配送不同）\n• **明天退房？** 可能会**错过配送** — **恕不退款**\n• 若部分商品**缺货**，我们将为**缺货部分退款**，其余商品照常发货',
    'zh-TW': '• **配送時間：明天**（與餐飲配送不同）\n• **明天退房嗎？** 您可能會**錯過配送** — **恕無法退款**\n• 若部分商品**缺貨**，我們將針對**缺貨商品退款**，其他商品照常出貨'
  },
  'cart.giftShopModalContinue': {
    en: 'Continue to Checkout',
    ko: '결제 계속하기',
    ja: '決済を続ける',
    'zh-CN': '繼續結算',
    'zh-TW': '繼續結算'
  },
  'cart.giftShopModalCancel': {
    en: 'Cancel',
    ko: '취소',
    ja: 'キャンセル',
    'zh-CN': '取消',
    'zh-TW': '取消'
  },
  
  // 메뉴 상세 페이지
  'menu.item': {
    en: 'Menu Item',
    ko: '메뉴 항목',
    ja: 'メニュー項目',
    'zh-CN': '菜單項',
    'zh-TW': '菜單項'
  },
  'quantity': {
    en: 'Quantity',
    ko: '數量',
    ja: '数量',
    'zh-CN': '數量',
    'zh-TW': '數量'
  },
  'menu.options': {
    en: 'Options',
    ko: '選項',
    ja: 'オプション',
    'zh-CN': '選項',
    'zh-TW': '選項'
  },
  'menu.totalPrice': {
    en: 'Total Price',
    ko: '總價',
    ja: '合計金額',
    'zh-CN': '總價',
    'zh-TW': '總價'
  },
  'menu.addToCart': {
    en: 'Add to Cart',
    ko: '장바구니에 추가',
    ja: 'カートに追加',
    'zh-CN': '加入購物車',
    'zh-TW': '加入購物車'
  },
  'menu.updateCart': {
    en: 'Update Cart',
    ko: '장바구니 업데이트',
    ja: 'カートを更新',
    'zh-CN': '更新購物車',
    'zh-TW': '更新購物車'
  },
  'menu.soldOut': {
    en: 'Sold Out',
    ko: '품절',
    ja: '売り切れ',
    'zh-CN': '售罄',
    'zh-TW': '售完'
  },

  // 결제 페이지 관련
  'checkout.email': {
    en: 'Email',
    ko: '이메일',
    ja: 'メールアドレス',
    'zh-CN': '電子郵件',
    'zh-TW': '電子郵件'
  },
  'checkout.enterEmail': {
    en: 'Enter your email address',
    ko: '이메일 주소를 입력하세요',
    ja: 'メールアドレスを入力してください',
    'zh-CN': '請輸入您的電子郵件地址',
    'zh-TW': '請輸入您的電子郵件地址'
  },
  'checkout.invalidEmail': {
    en: 'Please enter a valid email address',
    ko: '유효한 이메일 주소를 입력해주세요',
    ja: '有効なメールアドレスを入力してください',
    'zh-CN': '請輸入有效的電子郵件地址',
    'zh-TW': '請輸入有效的電子郵件地址'
  },
  'checkout.confirmationEmail': {
    en: 'Order confirmation will be sent to this email',
    ko: '주문 확인서가 이 이메일로 발송됩니다',
    ja: '注文確認はこのメールアドレスに送信されます',
    'zh-CN': '訂單確認將發送到此電子郵件',
    'zh-TW': '訂單確認將發送到此電子郵件'
  },
  'checkout.deliveryAddress': {
    en: 'Delivery Address',
    ko: '배달 주소',
    ja: '配達先住所',
    'zh-CN': '配送地址',
    'zh-TW': '配送地址'
  },
  'checkout.deliveryRequests': {
    en: 'Delivery Requests',
    ko: '배달 요청사항',
    ja: '配達リクエスト',
    'zh-CN': '配送要求',
    'zh-TW': '配送要求'
  },
  'checkout.noRingBell': {
    en: 'Please do not ring the bell or knock',
    ko: '벨을 누르지 말아주세요',
    ja: 'ベルやノックはご遠慮ください',
    'zh-CN': '請不要按門鈴或敲門',
    'zh-TW': '請不要按門鈴或敲門'
  },
  'checkout.leaveAtDoor': {
    en: 'Leave at the door or knock once',
    ko: '문 앞에 놓아주세요',
    ja: 'ドアの前に置くか、軽くノックしてください',
    'zh-CN': '請放在門口或輕敲一下門',
    'zh-TW': '請放在門口或輕敲一下門'
  },
  'checkout.callIfProblem': {
    en: 'Please deliver to the hotel front desk',
    ko: '문제가 있으면 전화해주세요',
    ja: 'ホテルのフロントにお届けください',
    'zh-CN': '請送到飯店櫃檯',
    'zh-TW': '請送到飯店櫃檯'
  },
  'checkout.stayingAtRoom': {
    en: 'Please add utensils',
    ko: '저는 [#]호에 머물고 있습니다',
    ja: 'お箸やスプーンをお願いします',
    'zh-CN': '請附上餐具',
    'zh-TW': '請附上餐具'
  },
  'checkout.addUtensils': {
    en: 'Please include napkins or tissues',
    ko: '수저를 추가해주세요',
    ja: '紙ナプキンやティッシュを入れてください',
    'zh-CN': '請附上紙巾或衛生紙',
    'zh-TW': '請附上紙巾或衛生紙'
  },
  'checkout.paymentMethod': {
    en: 'Payment Method',
    ko: '결제 방법',
    ja: '支払い方法',
    'zh-CN': '支付方式',
    'zh-TW': '支付方式'
  },
  'checkout.currency': {
    en: 'Currency',
    ko: '통화',
    ja: '通貨',
    'zh-CN': '貨幣',
    'zh-TW': '貨幣'
  },
  'checkout.paymentProcessing': {
    en: 'Payment complete. Your order is being processed. Details will be sent to your email shortly.',
    ko: '결제는 성공했지만 주문 처리 중 오류가 발생했습니다. 고객센터로 문의해주세요.',
    ja: 'お支払い完了。ご注文を処理中です。詳細はメールでお送りします。',
    'zh-CN': '付款成功，訂單處理中。詳細將發送至您的信箱。',
    'zh-TW': '付款成功，訂單處理中。詳細將發送至您的信箱。'
  },
  'checkout.eximbaySecure': {
    en: 'Secure payment with credit/debit card',
    ko: '신용카드/체크카드로 안전하게 결제하세요',
    ja: 'クレジットカード/デビットカードで安全にお支払い',
    'zh-CN': '使用信用卡/借记卡安全付款',
    'zh-TW': '使用信用卡/借記卡安全付款'
  },
  'checkout.eximbayOptions': {
    en: 'Visa, Mastercard, American Express and other major cards accepted',
    ko: 'Visa, Mastercard, American Express 등 주요 카드 사용 가능',
    ja: 'Visa、Mastercard、American Express等の主要カードをご利用いただけます',
    'zh-CN': '支持 Visa、Mastercard、American Express 등 주요卡片',
    'zh-TW': '支持 Visa、Mastercard、American Express 등 주요卡片'
  },
  'checkout.otherPaymentOptions': {
    en: 'Pay with',
    ko: '기타 결제 옵션',
    ja: 'お支払い方法:',
    'zh-CN': '使用',
    'zh-TW': '使用'
  },
  'checkout.otherPaymentSubtitle': {
    en: 'A new window for payment will open — please allow pop-ups',
    ko: '결제를 위해 새 창이 열립니다 — 팝업을 허용해주세요',
    ja: 'お支払いページが新しいウィンドウで開きます。ポップアップを許可してください',
    'zh-CN': '将跳转至新窗口完成支付，请允许弹窗',
    'zh-TW': '付款將於新視窗開啟，請允許彈出視窗'
  },
  'checkout.popupGuideLink': {
    en: 'View pop-up settings guide',
    ko: '팝업 설정 방법 보기',
    ja: 'ポップアップ設定ガイドを見る',
    'zh-CN': '查看弹窗设置指南',
    'zh-TW': '查看彈出視窗設定指南'
  },
  'checkout.paypalUnavailable.title': {
    en: 'PayPal Payment Temporarily Unavailable',
    ko: 'PayPal 결제 일시 중단',
    ja: 'PayPal決済が一時的に利用できません',
    'zh-CN': 'PayPal支付暂时不可用',
    'zh-TW': 'PayPal支付暫時不可用'
  },
  'checkout.paypalUnavailable.message': {
    en: 'PayPal payment is temporarily unavailable due to a technical issue. Please use the alternative payment method below.',
    ko: 'PayPal 결제에 일시적인 문제가 있어 현재 사용할 수 없습니다. 아래의 다른 결제 수단을 이용해 주세요.',
    ja: 'PayPal決済は技術的な問題により一時的に利用できません。下記の他の決済方法をご利用ください。',
    'zh-CN': 'PayPal支付因技术问题暂时不可用。请使用下方的其他支付方式。',
    'zh-TW': 'PayPal支付因技術問題暫時不可用。請使用下方的其他支付方式。'
  },
  'checkout.recommendedPayment': {
    en: 'Recommended',
    ko: '권장',
    ja: 'おすすめ',
    'zh-CN': '推荐',
    'zh-TW': '推薦'
  },
  'Terms of Use': {
    en: 'Terms of Use',
    ko: '이용약관',
    ja: '利用規約',
    'zh-CN': '服務條款',
    'zh-TW': '服務條款'
  },
  'Privacy Policy': {
    en: 'Privacy Policy',
    ko: '개인정보처리방침',
    ja: 'プライバシーポリシー',
    'zh-CN': '隐私政策',
    'zh-TW': '隱私政策'
  },
  'All rights reserved': {
    en: 'All rights reserved',
    ko: '모든 권리 보유',
    ja: 'すべての権利を保有',
    'zh-CN': '保留所有權利',
    'zh-TW': '保留所有權利'
  },
  'cart.replaceTitle': {
    en: 'One restaurant per order',
    ko: '한 번에 하나의 식당만 주문 가능',
    ja: '1店舗からのみ注文可能',
    'zh-CN': '每次只能從一家餐廳下單',
    'zh-TW': '一次只能從一家餐廳下單'
  },
  'cart.replaceMessage': {
    en: 'You can only order from one restaurant at a time. Would you like to clear your current cart and add this item instead?',
    ko: '한 번에 하나의 식당에서만 주문할 수 있습니다. 현재 장바구니를 비우고 이 항목을 추가하시겠습니까?',
    ja: '1店舗からのみご注文いただけます。現在のカートをクリアして、この商品を追加しますか？',
    'zh-CN': '每次只能從一家餐廳下單。是否要清空目前的購物車並新增這項商品？',
    'zh-TW': '一次只能從一家餐廳下單。是否要清空目前的購物車並新增這項商品？'
  },
  'cart.replace': {
    en: 'Replace Cart',
    ko: '장바구니 교체',
    ja: 'カートを置き換える',
    'zh-CN': '替換購物車',
    'zh-TW': '替換購物車'
  },
  'cart.cancel': {
    en: 'Cancel',
    ko: '취소',
    ja: 'キャンセル',
    'zh-CN': '取消',
    'zh-TW': '取消'
  },

  // 메뉴 섹션 이름
  'section.sides': {
    en: 'Sides',
    ko: '사이드',
    ja: 'サイド',
    'zh-CN': '配菜',
    'zh-TW': '配菜'
  },
  'section.sideDish': {
    en: 'Side Menu',
    ko: '사이드 메뉴',
    ja: 'サイドメニュー',
    'zh-CN': '小吃',
    'zh-TW': '小菜'
  },
  'section.sideMenu': {
    en: 'Side Menu',
    ko: '사이드 메뉴',
    ja: 'サイド',
    'zh-CN': '小吃',
    'zh-TW': '小菜'
  },
  'section.softDrink': {
    en: 'Soft Drink',
    ko: '음료',
    ja: 'ソフトドリンク',
    'zh-CN': '飲品',
    'zh-TW': '飲品'
  },
  'section.drinks': {
    en: 'Drinks',
    ko: '음료',
    ja: 'ドリンク',
    'zh-CN': '飲品',
    'zh-TW': '飲品'
  },
  'section.beverages': {
    en: 'Beverages',
    ko: '음료',
    ja: '飲み物',
    'zh-CN': '飲品',
    'zh-TW': '飲料'
  },

  // 운영시간 관련
  'service.closed.title': {
    en: 'Currently closed — We\'ll be back soon!',
    ko: '현재 운영 중단 — 곧 다시 돌아올게요!',
    ja: '現在休業中 — すぐに戻ります！',
    'zh-CN': '目前暫停營業 — 我們很快就回來！',
    'zh-TW': '目前暫停營業 — 我們很快就回來！'
  },
  'service.closed.message': {
    en: 'We are currently outside of our operating hours. Please try again during our service hours.',
    ko: '현재 운영시간이 아닙니다. 운영시간에 다시 이용해주세요.',
    ja: '現在営業時間外です。営業時間内に再度ご利用ください。',
    'zh-CN': '目前不在營業時間內，請於營業時間內再次嘗試。',
    'zh-TW': '目前不在營業時間內，請於營業時間內再次嘗試。'
  },
  'service.closed.autoClose': {
    en: 'This window will close automatically in 3 seconds',
    ko: '이 창은 3초 후 자동으로 닫힙니다',
    ja: 'このウィンドウは3秒後に自動的に閉じます',
    'zh-CN': '此視窗將在3秒後自動關閉',
    'zh-TW': '此視窗將在3秒後自動關閉'
  },

  // 운영 마감시간 30분 전 안내
  'service.closing.title': {
    en: 'Service closing soon — Order now!',
    ko: '곧 운영이 마감됩니다 — 지금 주문하세요!',
    ja: 'まもなく営業終了 — 今すぐご注文ください！',
    'zh-CN': '即將停止營業 — 請立即下單！',
    'zh-TW': '即將停止營業 — 請立即下單！'
  },
  'service.closing.message': {
    en: 'Our service will close in 30 minutes. Please complete your order soon to avoid any inconvenience.',
    ko: '30분 후 운영이 마감됩니다. 불편을 피하기 위해 빠른 시일 내에 주문을 완료해 주세요.',
    ja: '30分後に営業を終了いたします。ご不便をおかけしないよう、お早めにご注文をお済ませください。',
    'zh-CN': '我們將在30分鐘後停止營業。請儘快完成您的訂單，以免造成不便。',
    'zh-TW': '我們將在30分鐘後停止營業。請儘快完成您的訂單，以免造成不便。'
  },
  'service.closing.autoClose': {
    en: 'This window will close automatically in 5 seconds',
    ko: '이 창은 5초 후 자동으로 닫힙니다',
    ja: 'このウィンドウは5秒後に自動的に閉じます',
    'zh-CN': '此視窗將在5秒後自動關閉',
    'zh-TW': '此視窗將在5秒後自動關閉'
  },

  // 검색 결과 관련
  'search.noResults.title': {
    en: 'No restaurants found',
    ko: '검색 결과가 없습니다',
    ja: 'レストランが見つかりませんでした',
    'zh-CN': '未找到餐廳',
    'zh-TW': '未找到餐廳'
  },
  'search.noResults.message': {
    en: 'We couldn\'t find any restaurants serving "{menuName}" in your area.',
    ko: '해당 지역에서 "{menuName}"을(를) 판매하는 식당을 찾을 수 없습니다.',
    ja: 'お住まいの地域で"{menuName}"を提供するレストランが見つかりませんでした。',
    'zh-CN': '在您的地區找不到提供"{menuName}"的餐廳。',
    'zh-TW': '在您的地區找不到提供"{menuName}"的餐廳。'
  },
  'search.noResults.suggestions.title': {
    en: 'Try these suggestions:',
    ko: '다음 방법을 시도해보세요:',
    ja: '以下をお試しください：',
    'zh-CN': '請嘗試以下建議：',
    'zh-TW': '請嘗試以下建議：'
  },
  'search.noResults.suggestions.spelling': {
    en: 'Check your spelling',
    ko: '철자를 확인해보세요',
    ja: 'スペルを確認してください',
    'zh-CN': '檢查拼寫',
    'zh-TW': '檢查拼寫'
  },
  'search.noResults.suggestions.general': {
    en: 'Try a more general search term',
    ko: '더 일반적인 검색어를 사용해보세요',
    ja: 'より一般的な検索語を試してください',
    'zh-CN': '嘗試更通用的搜索詞',
    'zh-TW': '嘗試更通用的搜索詞'
  },
  'search.noResults.suggestions.browse': {
    en: 'Browse popular Korean dishes',
    ko: '인기 한국 요리를 둘러보세요',
    ja: '人気の韓国料理をご覧ください',
    'zh-CN': '瀏覽熱門韓國菜',
    'zh-TW': '瀏覽熱門韓國菜'
  },
  'search.noResults.actions.browseGuides': {
    en: 'Browse Food Guides',
    ko: '음식 가이드 보기',
    ja: 'フードガイドを見る',
    'zh-CN': '瀏覽美食指南',
    'zh-TW': '瀏覽美食指南'
  },
  'search.noResults.actions.exploreAll': {
    en: 'Explore All Restaurants',
    ko: '모든 식당 둘러보기',
    ja: 'すべてのレストランを探索',
    'zh-CN': '探索所有餐廳',
    'zh-TW': '探索所有餐廳'
  },
  'search.noResults.actions.browseOtherGuides': {
    en: 'Browse other guides',
    ko: '다른 가이드 보기',
    ja: '他のガイドを見る',
    'zh-CN': '瀏覽其他指南',
    'zh-TW': '瀏覽其他指南'
  },
  'search.noResults.actions.exploreNearby': {
    en: 'Explore all restaurants nearby',
    ko: '근처 모든 식당 둘러보기',
    ja: '近くのすべてのレストランを探す',
    'zh-CN': '探索附近所有餐廳',
    'zh-TW': '探索附近所有餐廳'
  },
  'search.noResults.mainMessage': {
    en: 'No \'{searchTerm}\' restaurants open nearby, but don\'t worry!',
    ko: '근처에 \'{searchTerm}\' 식당이 영업 중이지 않지만, 걱정하지 마세요!',
    ja: '近くに \'{searchTerm}\' のお店は営業していませんが、ご安心ください!',
    'zh-CN': '你附近暫無 \'{searchTerm}\' 餐廳營業中, 別擔心喔!',
    'zh-TW': '你附近暫無 \'{searchTerm}\' 餐廳營業中, 別擔心喔!'
  },
  'search.noResults.mainMessage.before': {
    en: 'No ',
    ko: '근처에 ',
    ja: '近くに ',
    'zh-CN': '你附近暫無 ',
    'zh-TW': '你附近暫無 '
  },
  'search.noResults.mainMessage.after': {
    en: ' restaurants open nearby, but don\'t worry!',
    ko: ' 식당이 영업 중이지 않지만, 걱정하지 마세요!',
    ja: ' のお店は営業していませんが、ご安心ください!',
    'zh-CN': ' 餐廳營業中, 別擔心喔!',
    'zh-TW': ' 餐廳營業中, 別擔心喔!'
  },
  'search.noResults.popular.title': {
    en: 'Popular searches:',
    ko: '인기 검색어:',
    ja: '人気の検索：',
    'zh-CN': '熱門搜索：',
    'zh-TW': '熱門搜索：'
  },
  'search.results.count': {
    en: '{count} restaurants found for "{menuName}"',
    ko: '"{menuName}"에 대한 검색 결과 {count}개',
    ja: '"{menuName}"の検索結果 {count}件',
    'zh-CN': '找到 {count} 家提供"{menuName}"的餐廳',
    'zh-TW': '找到 {count} 家提供"{menuName}"的餐廳'
  },
  
  // 가이드 배너 관련
  'guideBanner.title': {
    en: 'Food Guides',
    ko: '음식 가이드',
    ja: 'フードガイド',
    'zh-CN': '美食指南',
    'zh-TW': '美食指南'
  },
  'guideBanner.viewGuide': {
    en: 'View Guide',
    ko: '가이드 보기',
    ja: 'ガイドを見る',
    'zh-CN': '查看指南',
    'zh-TW': '查看指南'
  },

  // 상품 관련 (Product)
  'product.item': {
    en: 'Product',
    ko: '상품',
    ja: '商品',
    'zh-CN': '商品',
    'zh-TW': '商品'
  },
  'product.invalidId': {
    en: 'Invalid product or shop ID',
    ko: '잘못된 상품 또는 매장 ID입니다',
    ja: '無効な商品またはショップIDです',
    'zh-CN': '無效的商品或商店ID',
    'zh-TW': '無效的商品或商店ID'
  },
  'product.notFound': {
    en: 'Product not found',
    ko: '상품을 찾을 수 없습니다',
    ja: '商品が見つかりません',
    'zh-CN': '找不到商品',
    'zh-TW': '找不到商品'
  },
  'product.description': {
    en: 'Description',
    ko: '상품 설명',
    ja: '商品説明',
    'zh-CN': '商品描述',
    'zh-TW': '商品描述'
  },
  'product.basicInfo': {
    en: 'Basic Information',
    ko: '기본 정보',
    ja: '基本情報',
    'zh-CN': '基本信息',
    'zh-TW': '基本資訊'
  },
  'product.additionalInfo': {
    en: 'Additional Information',
    ko: '추가 정보',
    ja: '追加情報',
    'zh-CN': '附加信息',
    'zh-TW': '附加資訊'
  },
  'product.addToCart': {
    en: 'Add to Cart',
    ko: '장바구니에 추가',
    ja: 'カートに追加',
    'zh-CN': '加入購物車',
    'zh-TW': '加入購物車'
  },
  'product.goToShop': {
    en: 'Go to Shop',
    ko: '매장으로 이동',
    ja: 'ショップへ移動',
    'zh-CN': '前往商店',
    'zh-TW': '前往商店'
  },

  // 메인터넌스 페이지
  'maintenance.title': {
    en: 'Service Updating',
    ko: '서비스 업데이트 중',
    ja: 'サービス更新中',
    'zh-CN': '服务更新中',
    'zh-TW': '服務更新中'
  },
  'maintenance.message': {
    en: 'We are briefly updating our service to provide you with a better experience. Please wait a moment.',
    ko: '더 나은 서비스 제공을 위해 잠시 업데이트 중입니다. 조금만 기다려 주세요.',
    ja: 'より良いサービスを提供するため、しばらくアップデート中です。少々お待ちください。',
    'zh-CN': '我们正在进行短暂的服务更新，为您提供更好的体验。请稍等片刻。',
    'zh-TW': '我們正在進行短暫的服務更新，為您提供更好的體驗。請稍等片刻。'
  },
  'maintenance.checking': {
    en: 'Checking service status',
    ko: '서비스 상태 확인 중',
    ja: 'サービス状態確認中',
    'zh-CN': '检查服务状态中',
    'zh-TW': '檢查服務狀態中'
  },
  'maintenance.expectedTime': {
    en: 'This usually takes about 1 minute',
    ko: '보통 1분 정도 소요됩니다',
    ja: '通常1分程度かかります',
    'zh-CN': '通常需要约1分钟',
    'zh-TW': '通常需要約1分鐘'
  },

  // 프로모션 팝업
  'promotion.popup.title': {
    en: 'welcome bonus!',
    ko: '웰컴 보너스!',
    ja: 'ウェルカムボーナス！',
    'zh-CN': '欢迎奖励！',
    'zh-TW': '歡迎獎勵！',
  },
  'promotion.popup.deliveryFee': {
    en: 'Delivery Fee',
    ko: '배달비',
    ja: '配送料',
    'zh-CN': '配送费',
    'zh-TW': '配送費',
  },
  'promotion.popup.validUntil': {
    en: 'Valid until',
    ko: '유효기간',
    ja: '有効期限',
    'zh-CN': '有效期至',
    'zh-TW': '有效期至',
  },
  'promotion.popup.getPromoCode': {
    en: 'GET PROMO CODE',
    ko: '프로모션 코드 받기',
    ja: 'プロモコードを取得',
    'zh-CN': '获取促销代码',
    'zh-TW': '獲取促銷代碼',
  },
  'promotion.popup.dontShowAgain': {
    en: "Don't show again",
    ko: '그만 볼래요',
    ja: '今後表示しない',
    'zh-CN': '不再显示',
    'zh-TW': '不再顯示',
  },

  // 프로모션 성공 팝업 관련
  'promotion.success.title': {
    en: 'Check your inbox!',
    ko: '이메일을 확인해주세요!',
    ja: '受信ボックスを確認してください！',
    'zh-CN': '请查看您的收件箱！',
    'zh-TW': '請查看您的收件匣！',
  },
  'promotion.success.description1': {
    en: 'Your discount code is on the way.',
    ko: '할인 코드가 전송되고 있습니다.',
    ja: '割引コードを送信しました。',
    'zh-CN': '折扣码已发送。',
    'zh-TW': '折扣碼已發送。',
  },
  'promotion.success.description2': {
    en: "Check spam if you don't see it.",
    ko: '메일이 보이지 않으면 스팸함을 확인해주세요.',
    ja: '迷惑メールフォルダもご確認ください。',
    'zh-CN': '如未看到，请检查垃圾邮箱。',
    'zh-TW': '若未收到，請檢查垃圾郵件匣。',
  },
  'promotion.success.countdown': {
    en: '* This message closes in {seconds} seconds.',
    ko: '* 이 메시지는 {seconds}초 후에 닫힙니다.',
    ja: '* このメッセージは{seconds}秒後に自動で閉じます。',
    'zh-CN': '* 此消息将在{seconds}秒后自动关闭。',
    'zh-TW': '* 此訊息將在{seconds}秒後自動關閉。',
  },

  // 프로모션 배너 관련
  'promotion.banner.discountApplied': {
    en: 'Your discount is applied!',
    ko: '할인이 적용되었습니다!',
    ja: '割引が適用されました！',
    'zh-CN': '折扣已应用！',
    'zh-TW': '折扣已套用！',
  },
  'promotion.banner.stay_auto.active': {
    en: 'Stay promo active',
    ko: '숙소 혜택 적용됨',
    ja: '宿泊先特典を適用中',
    'zh-CN': '住宿优惠生效',
    'zh-TW': '住宿優惠生效',
  },
  'promotion.banner.user_code.active': {
    en: 'Promo code active',
    ko: '코드 혜택 적용됨',
    ja: 'コード特典を適用中',
    'zh-CN': '优惠码生效',
    'zh-TW': '優惠碼生效',
  },
  'promotion.banner.timeLeft': {
    en: 'Expires in {time}',
    ko: '{time} 후 만료',
    ja: '残り {time}',
    'zh-CN': '剩余 {time}',
    'zh-TW': '剩下 {time}',
  },
  'promotion.banner.expiresOn': {
    en: 'Expires on {date}',
    ko: '{date} 만료',
    ja: '{date} まで',
    'zh-CN': '{date} 截止',
    'zh-TW': '{date} 截止',
  },
  'promotion.banner.hours': {
    en: 'h',
    ko: '시간',
    ja: '時間',
    'zh-CN': '小时',
    'zh-TW': '小時',
  },
  'promotion.banner.minutes': {
    en: 'm',
    ko: '분',
    ja: '分',
    'zh-CN': '分钟',
    'zh-TW': '分鐘',
  },

  // 프로모션 페이지 관련
  'promotion.page.title': {
    en: 'Get Your First Meal Cheaper!',
    ko: '첫 주문을 더 저렴하게!',
    ja: '初回注文がおトクに！',
    'zh-CN': '首单超划算！',
    'zh-TW': '首單超划算！',
  },
  'promotion.page.benefit1': {
    en: 'Delivery Fee for your first order',
    ko: '첫 주문 배달비',
    ja: '初回注文の配達料',
    'zh-CN': '首单配送费',
    'zh-TW': '首單配送費',
  },
  'promotion.page.benefit1.free': {
    en: 'Free delivery for your first order',
    ko: '첫 주문 배달비 무료',
    ja: '初回注文限定：配達料無料',
    'zh-CN': '首单享免运费',
    'zh-TW': '首次下單享免運費',
  },
  'promotion.page.benefit1.discount': {
    en: '{discount} your delivery fee for your first order',
    ko: '첫 주문 배달비 {discount}',
    ja: '初回注文限定：配達料が{discount}',
    'zh-CN': '首单享运费{discount}',
    'zh-TW': '首次下單享運費{discount}',
  },
  'promotion.page.benefit2': {
    en: 'Korea\'s favorites: Fried Chicken, Tteokbokki & more',
    ko: '한국 인기 음식: 치킨, 떡볶이 등',
    ja: '韓国の人気グルメ：チキン、トッポッキなど',
    'zh-CN': '韩国人气美食：炸鸡、炒年糕等',
    'zh-TW': '韓國人氣美食：炸雞、辣炒年糕等',
  },
  'promotion.page.benefit3': {
    en: 'No Korean phone number or account needed',
    ko: '한국 전화번호나 계정 불필요',
    ja: '韓国の電話番号・アカウント不要',
    'zh-CN': '无需韩国手机号或账号',
    'zh-TW': '不需韓國手機門號或帳號',
  },
  'promotion.page.benefit4': {
    en: 'Fast, simple delivery — Just pick, pay, and relax!',
    ko: '빠르고 간단한 배달 — 선택하고, 결제하고, 기다리기만 하세요!',
    ja: '選んで、払って、あとは待つだけ！簡単配達',
    'zh-CN': '简单快捷：选好下单，安心等餐！',
    'zh-TW': '簡單又快速：選餐、付款、坐等送達！',
  },
  'promotion.page.emailLabel': {
    en: 'Email Address',
    ko: '이메일 주소',
    ja: 'メールアドレス',
    'zh-CN': '电子邮箱',
    'zh-TW': '電子信箱',
  },
  'promotion.page.emailPlaceholder': {
    en: 'Enter Your Email',
    ko: '이메일을 입력하세요',
    ja: 'メールアドレスを入力してください',
    'zh-CN': '請輸入您的電子郵件地址',
    'zh-TW': '請輸入您的電子信箱',
  },
  'promotion.page.emailNote': {
    en: '* We\'ll send you the discount code and a reminder before it expires',
    ko: '* 할인 코드와 만료 전 알림을 보내드립니다',
    ja: '* 割引コードと有効期限前のリマインダーをお送りします',
    'zh-CN': '* 我们将发送折扣码及到期提醒',
    'zh-TW': '* 我們會寄送折扣碼及到期前提醒',
  },
  'promotion.page.agreeEmails': {
    en: 'I agree to receive promotional emails',
    ko: '프로모션 이메일 수신에 동의합니다',
    ja: 'プロモーションメールの受信に同意します',
    'zh-CN': '我同意接收推广邮件',
    'zh-TW': '我同意接收行銷電子郵件',
  },
  'promotion.page.submitButton': {
    en: 'Get My Discount Code',
    ko: '할인 코드 받기',
    ja: '割引コードを受け取る',
    'zh-CN': '领取我的折扣码',
    'zh-TW': '領取我的折扣碼',
  },
  'promotion.page.submitting': {
    en: 'Submitting...',
    ko: '제출 중...',
    ja: '送信中...',
    'zh-CN': '提交中...',
    'zh-TW': '提交中...',
  },
  'promotion.page.validEmail': {
    en: 'Please enter a valid email address',
    ko: '유효한 이메일 주소를 입력해주세요',
    ja: '有効なメールアドレスを入力してください',
    'zh-CN': '请输入有效的电子邮件地址',
    'zh-TW': '請輸入有效的電子郵件地址',
  },
  'promotion.page.registrationFailed': {
    en: 'Registration failed. Please try again.',
    ko: '등록에 실패했습니다. 다시 시도해주세요.',
    ja: '登録に失敗しました。再度お試しください。',
    'zh-CN': '注册失败。请重试。',
    'zh-TW': '註冊失敗。請重試。',
  },
  
  // 온보딩 페이지
  'onboarding.welcome.title': {
    en: '🙌🏻 Welcome to Korea Order 🙌🏻',
    ja: '🙌🏻 ようこそ Korea Order へ 🙌🏻',
    'zh-TW': '🙌🏻 歡迎來到 Korea Order 🙌🏻',
    'zh-CN': '🙌🏻 欢迎来到 Korea Order 🙌🏻',
  },
  'onboarding.welcome.subtitle1': {
    en: 'Order like a local.',
    ja: '地元のように注文しましょう。',
    'zh-TW': '像在地人一樣點餐。',
    'zh-CN': '像本地人一样点餐。',
  },
  'onboarding.welcome.subtitle2': {
    en: 'Taste real Korea here!',
    ja: 'ここで本場の韓国の味を体験してください！',
    'zh-TW': '在這裡品嚐真正的韓國味道！',
    'zh-CN': '在这里品尝正宗韩国味道！',
  },
  'onboarding.next': {
    en: 'Next',
    ko: '다음',
    ja: '次へ',
    'zh-CN': '下一步',
    'zh-TW': '下一步',
  },
  'onboarding.skip': {
    en: 'Skip',
    ko: '건너뛰기',
    ja: 'スキップ',
    'zh-CN': '跳过',
    'zh-TW': '跳過',
  },
  
  // 공통 상단 문구 (2, 3, 4번째 페이지)
  'onboarding.how_it_works': {
    en: '✍🏻 How it works',
    ja: '✍🏻 使い方',
    'zh-TW': '✍🏻 使用方式',
    'zh-CN': '✍🏻 使用方式',
  },
  
  // 2번째 페이지
  'onboarding.no_login.title': {
    en: 'No login required',
    ja: 'ログイン不要',
    'zh-TW': '免登入',
    'zh-CN': '无需登录',
  },
  'onboarding.no_login.subtitle': {
    en: 'No Korean phone number needed.\nStart your order without sign-up!',
    ja: '韓国の電話番号も必要なし\n登録なしですぐに注文開始！',
    'zh-TW': '不需要韓國手機號碼\n無需註冊，立即下單！',
    'zh-CN': '不需要韩国手机号\n无需注册，马上下单！',
  },
  
  // 3번째 페이지
  'onboarding.address_set.title': {
    en: 'Address already set for you',
    ja: '住所はすでに設定済み',
    'zh-TW': '地址已為您設定好',
    'zh-CN': '地址已为您设置好',
  },
  'onboarding.address_set.subtitle': {
    en: 'Your host gave us a thumbs-up,\nso your address is all set—no extra steps!',
    ja: 'ホストが承認済みなので、追加手続きは不要です！',
    'zh-TW': '您的房東已經確認，無需其他步驟！',
    'zh-CN': '房东已确认，无需额外操作！',
  },
  'onboarding.address_screenshot.title': {
    en: 'No need to type tricky Korean address',
    ko: '복잡한 한국 주소를 입력할 필요 없어요',
    ja: '複雑な韓国住所の入力は不要',
    'zh-TW': '無需輸入複雜的韓國地址',
    'zh-CN': '无需输入复杂的韩国地址',
  },
  'onboarding.address_screenshot.subtitle': {
    en: 'Just upload a screenshot of your accommodation booking.\nWe\'ll set the address for you —no extra steps needed.',
    ko: '숙소 예약 스크린샷만 업로드해주세요.\n주소를 자동으로 설정해드립니다 —추가 단계 불필요.',
    ja: '宿泊予約のスクリーンショットをアップロードするだけ。\n住所を自動設定します —追加手順は不要。',
    'zh-TW': '只需上傳住宿預訂的截圖。\n我們會為您設定地址 —無需額外步驟。',
    'zh-CN': '只需上传住宿预订的截图。\n我们会为您设置地址 —无需额外步骤。',
  },
  
  // 4번째 페이지
  'onboarding.payment.title': {
    en: 'International cards OK',
    ja: '海外カードOK',
    'zh-TW': '國際信用卡可用',
    'zh-CN': '支持国际信用卡',
  },
  'onboarding.payment.subtitle': {
    en: 'Pay easily with Visa, Mastercard and more.\nRelax, your payment is powered by PayPal!',
    ja: 'Visa・Mastercardなど簡単決済\nPayPalで安心お支払い！',
    'zh-TW': '支援Visa、Mastercard等輕鬆付款\n用PayPal支付，安全又放心！',
    'zh-CN': '支持Visa、Mastercard等轻松支付\n使用PayPal，安全放心！',
  },
  
  // 네비게이션
  'onboarding.back': {
    en: 'Back',
    ko: '뒤로',
    ja: '戻る',
    'zh-CN': '返回',
    'zh-TW': '返回',
  },
  'onboarding.finish': {
    en: 'Get Started',
    ko: '시작하기',
    ja: '始める',
    'zh-CN': '开始使用',
    'zh-TW': '開始使用',
  },

  // 큐레이션 관련 번역
  'curation.title': {
    en: 'Recommend message',
    ko: '추천 메시지',
    ja: 'おすすめメッセージ',
    'zh-CN': '推荐信息',
    'zh-TW': '推薦信息'
  },
  'curation.viewMore': {
    en: 'View more',
    ko: '더보기',
    ja: 'もっと見る',
    'zh-CN': '查看更多',
    'zh-TW': '查看更多'
  },
  'curation.loading': {
    en: 'Loading recommendations...',
    ko: '추천 메뉴를 불러오는 중...',
    ja: 'おすすめを読み込み中...',
    'zh-CN': '正在加载推荐...',
    'zh-TW': '正在載入推薦...'
  },
  'curation.error': {
    en: 'Failed to load recommendations',
    ko: '추천 메뉴를 불러오지 못했습니다',
    ja: 'おすすめの読み込みに失敗しました',
    'zh-CN': '加载推荐失败',
    'zh-TW': '載入推薦失敗'
  },
  'curation.minOrder': {
    en: 'min. order',
    ko: '최소주문',
    ja: '最低注文',
    'zh-CN': '最低订单',
    'zh-TW': '最低訂單'
  },
  'curation.nearby': {
    en: 'Nearby',
    ko: '근처',
    ja: '近く',
    'zh-CN': '附近',
    'zh-TW': '附近'
  },
  'curation.category.MILD': {
    en: '😌 Mild: Korean, But Not Spicy',
    ko: '😌 순한맛',
    ja: '😌 辛くない韓国料理もあります',
    'zh-CN': '😌 并非所有韩国菜都很辣',
    'zh-TW': '😌 不全是辣的韓國料理'
  },
  'curation.category.KOREAN_BBQ': {
    en: 'Korean BBQ',
    ko: '한국식 바비큐',
    ja: '韓国焼肉',
    'zh-CN': '韩式烤肉',
    'zh-TW': '韓式燒烤'
  },
  'curation.category.FRIED_CHICKEN': {
    en: 'Fried Chicken',
    ko: '프라이드 치킨',
    ja: 'フライドチキン',
    'zh-CN': '炸鸡',
    'zh-TW': '炸雞'
  },
  'curation.category.ROSE_TTEOKBOKKI': {
    en: 'Rosé Tteokbokki',
    ko: '로제떡볶이',
    ja: 'ロゼトッポッキ',
    'zh-CN': '奶油辣炒年糕（Rosé）',
    'zh-TW': '奶油辣炒年糕（Rosé）'
  },
  'curation.category.JJAJANG': {
    en: 'Jjajangmyeon',
    ko: '짜장면',
    ja: 'ジャジャン麺（韓国風ジャージャー麺）',
    'zh-CN': '炸酱面（韩式）',
    'zh-TW': '炸醬麵（韓式）'
  },
  'curation.category.CHICKEN': {
    en: 'CHICKEN',
    ko: '치킨',
    ja: 'チキン',
    'zh-CN': '炸鸡',
    'zh-TW': '炸雞'
  },
  'curation.category.BIBIMBAP': {
    en: 'Bibimbap (Mixed Rice Bowl)',
    ko: '비빔밥',
    ja: 'ビビンバ（韓国風混ぜご飯）',
    'zh-CN': '拌饭（韩式拌饭）',
    'zh-TW': '拌飯（韓式拌飯）'
  },  
  'curation.category.SPICY': {
    en: '🔥 Dare to Go Spicy?',
    ko: '🔥 매운맛 도전해볼까요?',
    ja: '🔥 激辛に挑戦してみる？',
    'zh-CN': '🔥 敢挑战辣味吗？',
    'zh-TW': '🔥 敢挑戰辣味嗎？'
  },
  'curation.category.COFFEE': {
    en: '🍃 Need a Coffee/Tea Break?',
    ko: '🍃 커피나 차 한 잔 어때요?',
    ja: '🍃 カフェ・お茶休憩はいかが？',
    'zh-CN': '🍃 需要来杯咖啡或茶休息一下吗？',
    'zh-TW': '🍃 需要咖啡或茶的休息時間嗎？'
  },
  'curation.category.BRUNCH': {
    en: '🥪 Light Bite for the Afternoon?',
    ko: '🥪 오후 간단한 한 끼 어때요?',
    ja: '🥪 軽めの昼食にぴったり！',
    'zh-CN': '🥪 下午来点轻食？',
    'zh-TW': '🥪 下午輕食時間？'
  },
  'curation.category.SET': {
    en: '🍱 Not Sure? Go with a Set',
    ko: '🍱 고민된다면? 세트로 선택하세요',
    ja: '🍱 迷ったらセットがおすすめ！',
    'zh-CN': '🍱 不知道点什么？选套餐准没错！',
    'zh-TW': '🍱 不知道點什麼？選套餐就對了！'
  },
  'curation.category.MINIMUM': {
    en: 'Low-Minimum Meals',
    ko: '낮은 최소주문금액',
    ja: '最低注文額が低いお店',
    'zh-CN': '低起送價也能点的店铺',
    'zh-TW': '低消費金額也能點的店家'
  },
  'curation.category.STILL_OPEN': {
    en: '🌙 Still Open: After-Hours Picks',
    ko: '🌙 심야 영업: 늦은 시간에도 주문 가능',
    ja: '🌙 深夜でも営業中のお店',
    'zh-CN': '🌙 深夜也营业的店',
    'zh-TW': '🌙 深夜也開著的店'
  },
  'curation.category.ACTUAL_ORDER': {
    en: '🫶🏻 「Korea Order」 Users\' picks',
    ko: '🫶🏻 「Korea Order」 이용자들이 실제 주문한 곳',
    ja: '🫶🏻 『Korea Order』ユーザーが実際に注文した店',
    'zh-CN': '🫶🏻 『Korea Order』用户真实下单过的店',
    'zh-TW': '🫶🏻 『Korea Order』用戶實際點過的店'
  },
  'curation.category.NEAR_BY': {
    en: '📍 Nearby & Ready',
    ko: '📍 가까운 곳',
    ja: '📍 近くですぐ注文できる店',
    'zh-CN': '📍 附近可立即下单的店铺',
    'zh-TW': '📍 附近可立即訂餐的店家'
  },
  'curation.category.FAVORITE': {
    en: 'National favorites',
    ko: '프랜차이즈 브랜드 가게',
    ja: '全国チェーン店',
    'zh-CN': '全国连锁店',
    'zh-TW': '全韓連鎖店'
  },

  // 주문 성공 페이지
  'orderSuccess.title': {
    en: 'Payment Complete!',
    ko: '결제 완료!',
    ja: 'お支払い完了！',
    'zh-CN': '支付完成！',
    'zh-TW': '付款完成！',
  },
  'orderSuccess.paymentCurrency': {
    en: 'Payment Currency:',
    ko: '결제 통화:',
    ja: '決済通貨：',
    'zh-CN': '付款货币：',
    'zh-TW': '付款貨幣：',
  },
  'orderSuccess.confirmingOrder': {
    en: 'We are confirming your order',
    ko: '주문을 확인하고 있습니다',
    ja: 'ご注文を確認中です',
    'zh-CN': '正在确认您的订单',
    'zh-TW': '正在確認您的訂單',
  },
  'orderSuccess.processingTime': {
    en: 'This may take up to 5 minutes',
    ko: '최대 5분이 소요될 수 있습니다',
    ja: '最大5分かかる場合があります',
    'zh-CN': '这可能需要最多5分钟',
    'zh-TW': '這可能需要最多5分鐘',
  },
  'orderSuccess.emailNotification': {
    en: 'Order details will be shared via email',
    ko: '주문 상세 내역이 이메일로 전송됩니다',
    ja: '注文内容はメールで送信されます',
    'zh-CN': '订单详情将通过邮件发送',
    'zh-TW': '訂單詳情將透過電子郵件發送',
  },
  'orderSuccess.emailNotification.paid': {
    en: 'You will receive an email when your order is accepted',
    ko: '주문이 접수되면 이메일로 안내해 드립니다',
    ja: '注文が受付されるとメールでお知らせします',
    'zh-CN': '订单接收后将通过邮件通知您',
    'zh-TW': '訂單接收後將透過電子郵件通知您',
  },
  'orderSuccess.emailNotification.cooking': {
    en: 'You will receive an email when your delivery is complete',
    ko: '배달이 완료되면 이메일로 안내해 드립니다',
    ja: '配達完了時にメールでお知らせします',
    'zh-CN': '配送完成后将通过邮件通知您',
    'zh-TW': '配送完成後將透過電子郵件通知您',
  },
  'orderSuccess.returnToHome': {
    en: 'Return to Home',
    ko: '홈으로 돌아가기',
    ja: 'ホームに戻る',
    'zh-CN': '返回首页',
    'zh-TW': '返回首頁',
  },
  'orderSuccess.exploreMore': {
    en: 'Explore More Restaurants',
    ko: '더 많은 음식점 둘러보기',
    ja: '他のレストランを見る',
    'zh-CN': '探索更多餐厅',
    'zh-TW': '探索更多餐廳',
  },

  // 주문 상태 프로그레스 바
  'orderStatus.paid': {
    en: 'Payment',
    ko: '결제',
    ja: '決済',
    'zh-CN': '支付',
    'zh-TW': '付款',
  },
  'orderStatus.accepted': {
    en: 'Accepted',
    ko: '접수',
    ja: '受付',
    'zh-CN': '接单',
    'zh-TW': '接單',
  },
  'orderStatus.cooking': {
    en: 'Cooking',
    ko: '조리중',
    ja: '調理中',
    'zh-CN': '烹饪中',
    'zh-TW': '烹飪中',
  },
  'orderStatus.delivered': {
    en: 'Delivered',
    ko: '배달완료',
    ja: '配達完了',
    'zh-CN': '已送达',
    'zh-TW': '已送達',
  },

  // 주문 상태별 타이틀
  'orderSuccess.title.paid': {
    en: 'Payment Complete!',
    ko: '결제 완료!',
    ja: 'お支払い完了！',
    'zh-CN': '支付完成！',
    'zh-TW': '付款完成！',
  },
  'orderSuccess.title.accepted': {
    en: 'Order Accepted!',
    ko: '주문 접수 완료!',
    ja: '注文受付完了！',
    'zh-CN': '订单已接收！',
    'zh-TW': '訂單已接收！',
  },
  'orderSuccess.title.cooking': {
    en: 'Now Cooking!',
    ko: '조리 중!',
    ja: '調理中！',
    'zh-CN': '烹饪中！',
    'zh-TW': '烹飪中！',
  },
  'orderSuccess.title.delivered': {
    en: 'Delivery Complete!',
    ko: '배달 완료!',
    ja: '配達完了！',
    'zh-CN': '已送达！',
    'zh-TW': '已送達！',
  },

  // 주문 상태별 안내 메시지 1
  'orderSuccess.message1.paid': {
    en: 'We are confirming your order',
    ko: '주문을 확인하고 있습니다',
    ja: 'ご注文を確認中です',
    'zh-CN': '正在确认您的订单',
    'zh-TW': '正在確認您的訂單',
  },
  'orderSuccess.message1.accepted': {
    en: 'Our staff is reviewing your order',
    ko: '담당자가 주문을 확인 중입니다',
    ja: '担当者が注文を確認中です',
    'zh-CN': '工作人员正在确认您的订单',
    'zh-TW': '工作人員正在確認您的訂單',
  },
  'orderSuccess.message1.cooking': {
    en: 'Your food is being prepared',
    ko: '음식을 준비하고 있습니다',
    ja: 'お料理を準備しています',
    'zh-CN': '正在准备您的食物',
    'zh-TW': '正在準備您的餐點',
  },
  'orderSuccess.message1.delivered': {
    en: 'Your order has been delivered',
    ko: '주문하신 음식이 배달되었습니다',
    ja: 'ご注文の料理が配達されました',
    'zh-CN': '您的订单已送达',
    'zh-TW': '您的訂單已送達',
  },

  // 주문 상태별 안내 메시지 2
  'orderSuccess.message2.paid': {
    en: 'This may take up to 5 minutes',
    ko: '최대 5분이 소요될 수 있습니다',
    ja: '最大5分かかる場合があります',
    'zh-CN': '这可能需要最多5分钟',
    'zh-TW': '這可能需要最多5分鐘',
  },
  'orderSuccess.message2.accepted': {
    en: 'The restaurant will start preparing your food soon',
    ko: '곧 조리가 시작됩니다',
    ja: 'まもなく調理が始まります',
    'zh-CN': '餐厅即将开始准备',
    'zh-TW': '餐廳即將開始準備',
  },
  'orderSuccess.message2.cooking': {
    en: 'Please wait a little longer',
    ko: '조금만 더 기다려주세요',
    ja: 'もう少々お待ちください',
    'zh-CN': '请再稍等片刻',
    'zh-TW': '請再稍等片刻',
  },
  'orderSuccess.message2.delivered': {
    en: 'Enjoy your meal!',
    ko: '맛있게 드세요!',
    ja: 'ごゆっくりお召し上がりください！',
    'zh-CN': '请享用！',
    'zh-TW': '請享用！',
  },

  // 최근 주문 내역 페이지
  'orders.title': {
    en: 'Orders',
    ko: '주문 내역',
    ja: '注文履歴',
    'zh-CN': '订单',
    'zh-TW': '訂單',
  },
  'orders.description': {
    en: 'Check paid orders from the last 12 hours.',
    ko: '최근 12시간 내 결제한 주문을 확인할 수 있어요.',
    ja: '過去12時間以内に支払った注文を確認できます。',
    'zh-CN': '可查看最近12小时内已付款的订单。',
    'zh-TW': '可查看最近12小時內已付款的訂單。',
  },
  'orders.currentAddress': {
    en: 'Current address',
    ko: '현재 주소',
    ja: '現在の住所',
    'zh-CN': '当前地址',
    'zh-TW': '目前地址',
  },
  'orders.refresh': {
    en: 'Refresh',
    ko: '새로고침',
    ja: '更新',
    'zh-CN': '刷新',
    'zh-TW': '重新整理',
  },
  'orders.recentOrders': {
    en: 'Recent orders',
    ko: '최근 주문',
    ja: '最近の注文',
    'zh-CN': '最近订单',
    'zh-TW': '最近訂單',
  },
  'orders.loading': {
    en: 'Loading orders...',
    ko: '주문 내역을 불러오는 중...',
    ja: '注文履歴を読み込み中...',
    'zh-CN': '正在加载订单...',
    'zh-TW': '正在載入訂單...',
  },
  'orders.addressRequiredTitle': {
    en: 'Set your address first',
    ko: '주소를 먼저 설정해주세요',
    ja: '先に住所を設定してください',
    'zh-CN': '请先设置地址',
    'zh-TW': '請先設定地址',
  },
  'orders.addressRequiredDescription': {
    en: 'Orders are shown based on your current address.',
    ko: '현재 주소를 기준으로 주문 내역을 보여드려요.',
    ja: '現在の住所を基準に注文履歴を表示します。',
    'zh-CN': '订单会按当前地址显示。',
    'zh-TW': '訂單會依目前地址顯示。',
  },
  'orders.setAddress': {
    en: 'Set Address',
    ko: '주소 설정하기',
    ja: '住所を設定',
    'zh-CN': '设置地址',
    'zh-TW': '設定地址',
  },
  'orders.emptyTitle': {
    en: 'No recent orders',
    ko: '최근 주문이 없어요',
    ja: '最近の注文はありません',
    'zh-CN': '暂无最近订单',
    'zh-TW': '暫無最近訂單',
  },
  'orders.emptyDescription': {
    en: 'Your paid orders will appear here.',
    ko: '결제한 주문이 이곳에 표시됩니다.',
    ja: '支払い済みの注文がここに表示されます。',
    'zh-CN': '已付款的订单会显示在这里。',
    'zh-TW': '已付款的訂單會顯示在這裡。',
  },
  'orders.emptyHint': {
    en: 'Just paid? Check again in a moment.',
    ko: '방금 결제했나요? 잠시 후 다시 확인해보세요.',
    ja: '支払い直後ですか？少し待ってから再度確認してください。',
    'zh-CN': '刚付款了吗？请稍后再查看。',
    'zh-TW': '剛付款了嗎？請稍後再查看。',
  },
  'orders.checkAgain': {
    en: 'Check again',
    ko: '다시 확인',
    ja: '再度確認',
    'zh-CN': '再次查看',
    'zh-TW': '再次查看',
  },
  'orders.browseRestaurants': {
    en: 'Browse Restaurants',
    ko: '음식점 둘러보기',
    ja: 'レストランを見る',
    'zh-CN': '浏览餐厅',
    'zh-TW': '瀏覽餐廳',
  },
  'orders.errorTitle': {
    en: 'Could not load orders',
    ko: '주문 내역을 불러오지 못했어요',
    ja: '注文履歴を読み込めませんでした',
    'zh-CN': '无法加载订单',
    'zh-TW': '無法載入訂單',
  },
  'orders.errorDescription': {
    en: 'Please try again in a moment.',
    ko: '잠시 후 다시 시도해주세요.',
    ja: 'しばらくしてからもう一度お試しください。',
    'zh-CN': '请稍后重试。',
    'zh-TW': '請稍後再試。',
  },
  'orders.retry': {
    en: 'Try Again',
    ko: '다시 시도',
    ja: '再試行',
    'zh-CN': '重试',
    'zh-TW': '重試',
  },
  'orders.paidAt': {
    en: 'Paid',
    ko: '결제',
    ja: '支払い',
    'zh-CN': '付款',
    'zh-TW': '付款',
  },
  'orders.expectedDelivery': {
    en: 'Expected delivery',
    ko: '예상 도착',
    ja: '到着予定',
    'zh-CN': '预计送达',
    'zh-TW': '預計送達',
  },
  'orders.deliveryCompletedAt': {
    en: 'Delivery completed',
    ko: '배달 완료',
    ja: '配達完了',
    'zh-CN': '送达时间',
    'zh-TW': '送達時間',
  },
  'orders.menuSummary': {
    en: 'Menu',
    ko: '메뉴',
    ja: 'メニュー',
    'zh-CN': '菜单',
    'zh-TW': '菜單',
  },
  'orders.progressLabel': {
    en: 'Order progress',
    ko: '주문 진행 상태',
    ja: '注文進行状況',
    'zh-CN': '订单进度',
    'zh-TW': '訂單進度',
  },
  'orders.affordance.remainingMinutes': {
    en: 'About {minutes} min left',
    ko: '약 {minutes}분 남음',
    ja: 'あと約{minutes}分',
    'zh-CN': '约剩{minutes}分钟',
    'zh-TW': '約剩{minutes}分鐘',
  },
  'orders.affordance.remainingMinutesCompact': {
    en: '{minutes}m',
    ko: '{minutes}분',
    ja: '{minutes}分',
    'zh-CN': '{minutes}分钟',
    'zh-TW': '{minutes}分鐘',
  },
  'orders.affordance.arrivingSoon': {
    en: 'Arriving soon',
    ko: '곧 도착',
    ja: 'まもなく到着',
    'zh-CN': '即将送达',
    'zh-TW': '即將送達',
  },
  'orders.affordance.viewOrders': {
    en: 'View orders',
    ko: '주문 내역 보기',
    ja: '注文履歴を見る',
    'zh-CN': '查看订单',
    'zh-TW': '查看訂單',
  },
  'orders.hiddenItems': {
    en: '+{count} more',
    ko: '외 {count}개',
    ja: '他{count}点',
    'zh-CN': '另有{count}件',
    'zh-TW': '另有{count}件',
  },
  'orders.totalQuantity': {
    en: '{count} items total',
    ko: '총 {count}개',
    ja: '合計{count}点',
    'zh-CN': '共{count}件',
    'zh-TW': '共{count}件',
  },
  'orders.note': {
    en: 'Note:',
    ko: '요청사항:',
    ja: 'リクエスト:',
    'zh-CN': '备注：',
    'zh-TW': '備註：',
  },
  'orders.status.paid': {
    en: 'Paid',
    ko: '결제 완료',
    ja: '支払い完了',
    'zh-CN': '已付款',
    'zh-TW': '已付款',
  },
  'orders.status.accepted': {
    en: 'Accepted',
    ko: '주문 접수',
    ja: '注文受付',
    'zh-CN': '已接单',
    'zh-TW': '已接單',
  },
  'orders.status.cooking': {
    en: 'Cooking',
    ko: '조리 중',
    ja: '調理中',
    'zh-CN': '制作中',
    'zh-TW': '製作中',
  },
  'orders.status.delivered': {
    en: 'Delivered',
    ko: '배달 완료',
    ja: '配達完了',
    'zh-CN': '已送达',
    'zh-TW': '已送達',
  },
  'orders.status.cancelled': {
    en: 'Cancelled',
    ko: '주문 취소',
    ja: '注文キャンセル',
    'zh-CN': '订单已取消',
    'zh-TW': '訂單已取消',
  },
  'orders.statusDescription.paid': {
    en: 'We are confirming your order.',
    ko: '주문을 확인하고 있습니다.',
    ja: '注文を確認しています。',
    'zh-CN': '正在确认您的订单。',
    'zh-TW': '正在確認您的訂單。',
  },
  'orders.statusDescription.accepted': {
    en: 'Your order has been accepted.',
    ko: '주문이 접수되었습니다.',
    ja: '注文が受け付けられました。',
    'zh-CN': '您的订单已接单。',
    'zh-TW': '您的訂單已接單。',
  },
  'orders.statusDescription.cooking': {
    en: 'Your food is being prepared.',
    ko: '음식을 준비하고 있습니다.',
    ja: '料理を準備しています。',
    'zh-CN': '正在准备您的餐点。',
    'zh-TW': '正在準備您的餐點。',
  },
  'orders.statusDescription.delivered': {
    en: 'Your order has been delivered.',
    ko: '주문하신 음식이 배달되었습니다.',
    ja: '注文が配達されました。',
    'zh-CN': '您的订单已送达。',
    'zh-TW': '您的訂單已送達。',
  },
  'orders.statusDescription.cancelled': {
    en: 'This order was cancelled.',
    ko: '취소된 주문입니다.',
    ja: 'この注文はキャンセルされました。',
    'zh-CN': '此订单已取消。',
    'zh-TW': '此訂單已取消。',
  },

  // 팝업 블록 관련
  'checkout.popupBlocked.title': {
    en: 'Popup Blocked',
    ko: '팝업 차단됨',
    ja: 'ポップアップがブロックされました',
    'zh-CN': '弹窗已被阻止',
    'zh-TW': '彈窗已被封鎖'
  },
  'checkout.popupBlocked.message': {
    en: 'Your browser has blocked the payment popup. Please allow popups to proceed with payment.',
    ko: '브라우저에서 결제 팝업을 차단했습니다. 팝업을 허용한 후 다시 시도해주세요.',
    ja: 'ブラウザが決済ポップアップをブロックしました。ポップアップを許可してから再度お試しください。',
    'zh-CN': '浏览器已阻止支付弹窗。请允许弹窗后重试。',
    'zh-TW': '瀏覽器已封鎖付款彈窗。請允許彈窗後重試。'
  },
  'checkout.popupBlocked.instruction.ios': {
    en: 'iPhone/iPad: Settings > Safari > Turn off "Block Pop-ups"',
    ko: 'iPhone/iPad: 설정 > Safari > "팝업 차단" 끄기',
    ja: 'iPhone/iPad: 設定 > Safari > 「ポップアップブロック」をオフ',
    'zh-CN': 'iPhone/iPad：设置 > Safari > 关闭"阻止弹出式窗口"',
    'zh-TW': 'iPhone/iPad：設定 > Safari > 關閉「阻擋彈出式視窗」'
  },
  'checkout.popupBlocked.instruction.other': {
    en: 'Other browsers: Enable popups in browser settings',
    ko: '기타 브라우저: 브라우저 설정에서 팝업 허용',
    ja: 'その他のブラウザ: ブラウザ設定でポップアップを許可',
    'zh-CN': '其他浏览器：在浏览器设置中允许弹窗',
    'zh-TW': '其他瀏覽器：在瀏覽器設定中允許彈窗'
  },
  'checkout.popupBlocked.refresh': {
    en: 'Refresh Page',
    ko: '페이지 새로고침',
    ja: 'ページを更新',
    'zh-CN': '刷新页面',
    'zh-TW': '重新整理頁面'
  },

  // FAQ 페이지
  'faq.title': {
    en: 'FAQ',
    ko: 'FAQ',
    ja: 'FAQ',
    'zh-CN': 'FAQ',
    'zh-TW': 'FAQ'
  },
  'faq.search.placeholder': {
    en: 'Search',
    ko: '검색',
    ja: '検索',
    'zh-CN': '搜索',
    'zh-TW': '搜尋'
  },
  'faq.getHelpNow': {
    en: 'Get Help Now',
    ko: '지금 도움받기',
    ja: '今すぐヘルプ',
    'zh-CN': '立即获取帮助',
    'zh-TW': '立即獲取幫助'
  },
  'faq.getHelpDescription': {
    en: 'Chat with us — we support English, Japanese, and Chinese.',
    ko: '채팅으로 문의하세요 — 한국어, 영어, 일본어, 중국어를 지원합니다.',
    ja: 'チャットでお問い合わせください — 日本語、英語、中国語をサポートしています。',
    'zh-CN': '与我们聊天 — 我们支持中文、英语和日语。',
    'zh-TW': '與我們聊天 — 我們支援中文、英語和日語。'
  },
  'faq.cantFindAnswer': {
    en: 'Can\'t find what you\'re looking for in the FAQ?',
    ko: 'FAQ에서 찾고 계신 내용이 없나요?',
    ja: 'FAQでお探しの内容が見つからない場合は？',
    'zh-CN': '在FAQ中找不到您要找的内容？',
    'zh-TW': '在FAQ中找不到您要找的內容？'
  },
  'faq.section.serviceOverview': {
    en: 'Service Overview',
    ko: '서비스 개요',
    ja: 'サービス紹介',
    'zh-CN': '服务介绍',
    'zh-TW': '服務介紹'
  },
  'faq.section.orderPayment': {
    en: 'Order & Payment',
    ko: '주문 & 결제',
    ja: '注文・支払いについて',
    'zh-CN': '订单/付款问题',
    'zh-TW': '訂單/付款問題'
  },
  'faq.section.deliveryTime': {
    en: 'Delivery Time',
    ko: '배달 시간',
    ja: '配達と時間について',
    'zh-CN': '配送与时间',
    'zh-TW': '配送與時間'
  },
  'faq.section.cancelIssues': {
    en: 'Cancel / Issues',
    ko: '취소 / 문제해결',
    ja: '変更・問題対応',
    'zh-CN': '更改／问题处理',
    'zh-TW': '更改／問題處理'
  },
  'faq.section.languageOthers': {
    en: 'Language & Others',
    ko: '언어 & 기타',
    ja: '言語・その他の質問',
    'zh-CN': '语言／其他问题',
    'zh-TW': '語言／其他問題'
  },
  'faq.noResults': {
    en: 'No results found for your search.',
    ko: '검색 결과가 없습니다.',
    ja: '検索結果が見つかりませんでした。',
    'zh-CN': '未找到搜索结果。',
    'zh-TW': '未找到搜索結果。'
  },
  
  // 스크린샷 업로드 페이지
  'address.screenshot.title': {
    en: 'via Screenshot',
    ko: '스크린샷으로',
    ja: 'スクリーンショットで',
    'zh-CN': '通过截图',
    'zh-TW': '透過截圖'
  },
  'address.screenshot.instruction.screenshot': {
    en: 'Please upload a screenshot, not a photo',
    ko: '사진이 아닌 스크린샷을 업로드해주세요',
    ja: '写真ではなくスクリーンショットをアップロードしてください',
    'zh-CN': '请上传截图，不是照片',
    'zh-TW': '請上傳截圖，不是照片'
  },
  'address.screenshot.instruction.fullAddress': {
    en: 'Include the full address with building number',
    ko: '건물 번호가 포함된 전체 주소를 포함해주세요',
    ja: '建物番号を含む完全な住所を含めてください',
    'zh-CN': '包括带建筑号码的完整地址',
    'zh-TW': '包括帶建築號碼的完整地址'
  },
  'address.screenshot.instruction.hostMessage': {
    en: 'Best: capture it from your host message',
    ko: '최고: 호스트 메시지에서 캡처하세요',
    ja: '最適：ホストメッセージからキャプチャしてください',
    'zh-CN': '最佳：从房东消息中截取',
    'zh-TW': '最佳：從房東訊息中截取'
  },
  'address.screenshot.uploadButton': {
    en: 'Auto-Set via Pic',
    ko: '사진으로 자동 설정',
    ja: '画像で自動設定',
    'zh-CN': '通过图片自动设置',
    'zh-TW': '透過圖片自動設定'
  },
  'address.screenshot.uploading': {
    en: 'Uploading...',
    ko: '업로드 중...',
    ja: 'アップロード中...',
    'zh-CN': '上传中...',
    'zh-TW': '上傳中...'
  },
  
  // 스크린샷 업로드 성공 팝업
  'popup.screenshot.title': {
    en: 'Screenshot received!',
    ko: '스크린샷이 접수되었습니다!',
    ja: 'スクリーンショットを受信しました！',
    'zh-CN': '截图已收到！',
    'zh-TW': '截圖已收到！'
  },
  'popup.screenshot.setupTime': {
    en: 'Setup takes ~3 mins',
    ko: '설정까지 약 3분 소요',
    ja: 'セットアップには約3分かかります',
    'zh-CN': '设置需要约3分钟',
    'zh-TW': '設定需要約3分鐘'
  },
  'popup.screenshot.notification': {
    en: "We'll notify you once your address is ready",
    ko: '주소가 준비되면 알려드리겠습니다',
    ja: '住所の準備ができたらお知らせします',
    'zh-CN': '地址准备好后我们会通知您',
    'zh-TW': '地址準備好後我們會通知您'
  },
  'popup.screenshot.imageDelete': {
    en: '* Your image will be deleted after setup.',
    ko: '* 설정 완료 후 이미지가 삭제됩니다.',
    ja: '* セットアップ後、画像は削除されます。',
    'zh-CN': '* 设置完成后将删除您的图片。',
    'zh-TW': '* 設定完成後將刪除您的圖片。'
  },
  'popup.screenshot.confirm': {
    en: 'OK',
    ko: '확인',
    ja: '確認',
    'zh-CN': '确定',
    'zh-TW': '確定'
  },

  // 뱃지 관련 번역 키 추가
  'badge.orderNow': { en: 'Within 1 hour', ko: '1시간 이내', ja: '1時間以内', 'zh-CN': '1小時內', 'zh-TW': '1小時內' },
  'badge.orderLater': { en: 'Later Today', ja: '後で注文', 'zh-CN': '稍后下单', 'zh-TW': '稍後下單' },
  'restaurant.minOrder': { en: 'min. order', ja: '最小注文', 'zh-CN': '最低订单', 'zh-TW': '最低訂單' },

  // Stay 로드 실패 토스트
  'stay.loadError': {
    en: 'Failed to load accommodation info.',
    ko: '숙소 정보를 불러오지 못했습니다.',
    ja: '宿泊施設情報の読み込みに失敗しました。',
    'zh-CN': '加载住宿信息失败。',
    'zh-TW': '載入住宿資訊失敗。'
  },
  'stay.retry': {
    en: 'Retry',
    ko: '재시도',
    ja: '再試行',
    'zh-CN': '重试',
    'zh-TW': '重試'
  },
};

/**
 * 번역 키에 해당하는 다국어 텍스트 반환
 * @param key 번역 키
 * @param lang 언어 코드 (기본값: 현재 설정된 언어)
 * @returns 번역된 텍스트
 */
export const getTranslation = (key: string, lang?: SupportedLanguage): string => {
  // 키가 없는 경우 빈 문자열 반환
  if (!key) return '';
  
  // 전역에서 불러올 현재 언어
  let currentLang = lang;
  
  // 브라우저 환경에서만 실행
  if (typeof window !== 'undefined' && !currentLang) {
    try {
      // localStorage에서 현재 언어 설정 가져오기
      const savedLang = localStorage.getItem('app_language') as SupportedLanguage | null;
      if (savedLang && ['en', 'ko', 'ja', 'zh-CN', 'zh-TW'].includes(savedLang)) {
        currentLang = savedLang;
      }
    } catch (e) {
      console.error('언어 설정 불러오기 실패:', e);
    }
  }
  
  // 현재 언어 없으면 영어 기본값 사용
  if (!currentLang) {
    currentLang = 'en';
  }
  
  // 번역 키가 사전에 있는지 확인
  const translationItem = translations[key];
  if (!translationItem) {
    console.warn(`번역 키 "${key}"를 찾을 수 없습니다.`);
    return key; // 키를 그대로 반환
  }
  
  // 현재 언어에 해당하는 번역이 있으면 반환, 없으면 영어 기본값 반환
  const translatedText = translationItem[currentLang];
  return translatedText || translationItem.en || key;
};

// 다국어 훅 사용을 위한 간단한 wrapper
export const t = getTranslation;

export default translations;
